var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgFlipBack3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 212,
    viewBox: "0 0 342 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_1314)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint0_linear_150_1314)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447 122.094C545 395.094 252.28 380.594 112 380.594C-28.2803 380.594 -142 272.023 -142 138.094C-142 4.16454 -64.2803 183.094 76 183.094C217.5 190.094 349 -84.4063 447 122.094Z",
    fill: "#5BA6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.195 39.8084C297.809 35.9333 295.302 33.2843 293.597 33.8941C291.891 34.5038 291.64 38.135 293.026 42.0102C294.412 45.8853 296.919 48.5343 298.625 47.9245C300.33 47.3148 300.582 43.6836 299.195 39.8152V39.8084Z",
    fill: "url(#paint1_linear_150_1314)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M295.832 34.0567C297.205 34.9577 298.659 37.0376 299.603 39.6662C300.548 42.2947 300.745 44.8217 300.255 46.3867L300.602 47.3555L298.964 47.9381H298.951L298.93 47.9516H298.91C297.177 48.5275 294.656 45.8447 293.257 41.9289C291.857 38.0199 292.102 34.348 293.8 33.6908L295.492 33.0879L295.839 34.0567H295.832Z",
    fill: "url(#paint2_linear_150_1314)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.179 39.1038C299.766 35.1609 297.218 32.4713 295.485 33.0878C293.753 33.7043 293.495 37.3966 294.908 41.3395C296.321 45.2756 298.869 47.9719 300.602 47.3554C302.334 46.7389 302.593 43.0467 301.179 39.1038Z",
    fill: "url(#paint3_linear_150_1314)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.144 34.0635C294.731 34.5648 294.554 37.688 295.75 41.0347C296.946 44.3814 299.073 46.6848 300.486 46.1835C301.9 45.6822 302.076 42.559 300.88 39.2123C299.678 35.8656 297.558 33.5622 296.144 34.0635Z",
    fill: "url(#paint4_linear_150_1314)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M296.131 34.6597C294.826 35.1271 294.656 37.9793 295.75 41.0347C296.844 44.0901 298.794 46.197 300.099 45.7296C301.404 45.2621 301.573 42.4099 300.479 39.3545C299.386 36.2991 297.435 34.1922 296.131 34.6597Z",
    fill: "url(#paint5_radial_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M296.131 34.6597C294.826 35.1271 294.656 37.9793 295.75 41.0347C296.844 44.0901 298.794 46.197 300.099 45.7296C301.404 45.2621 301.573 42.4099 300.479 39.3545C299.386 36.2991 297.435 34.1922 296.131 34.6597Z",
    fill: "url(#paint6_radial_150_1314)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.825 41.0076C294.731 37.9522 294.928 35.0797 296.273 34.6055C297.619 34.1245 299.596 36.2178 300.69 39.2732C301.784 42.3286 301.587 45.1944 300.242 45.6754C298.896 46.1564 296.919 44.063 295.825 41.0076ZM301.342 39.0429C299.956 35.1678 297.449 32.5188 295.743 33.1286C294.038 33.7383 293.787 37.3695 295.173 41.2447C296.559 45.1198 299.066 47.7688 300.772 47.159C302.477 46.5493 302.728 42.918 301.342 39.0497V39.0429Z",
    fill: "url(#paint7_linear_150_1314)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300.051 40.1065L299.671 39.0497L299.29 39.1851C299.182 38.8735 299.053 38.5822 298.917 38.3112C298.781 38.0402 298.638 37.8099 298.489 37.6134C298.346 37.4237 298.196 37.2814 298.054 37.1866C297.911 37.0918 297.768 37.0714 297.639 37.1189C297.463 37.1798 297.347 37.3153 297.3 37.5186C297.252 37.7218 297.232 37.9521 297.252 38.2164C297.272 38.4806 297.313 38.7651 297.381 39.0564C297.449 39.3545 297.51 39.6255 297.565 39.8762C297.619 40.1268 297.66 40.3436 297.68 40.513C297.7 40.6891 297.68 40.7908 297.612 40.8111C297.571 40.8246 297.517 40.7908 297.449 40.7095C297.381 40.6282 297.313 40.4791 297.238 40.2759C297.13 39.9778 297.075 39.6932 297.069 39.429C297.069 39.1648 297.116 38.9616 297.232 38.8396L296.749 37.4915L295.764 37.8437L296.246 39.1919L296.403 39.1377C296.437 39.49 296.498 39.8287 296.572 40.1404L296.158 40.2894L296.539 41.3463L296.912 41.2108C297.028 41.5224 297.157 41.8137 297.293 42.0847C297.429 42.3557 297.565 42.5928 297.707 42.7825C297.85 42.979 297.993 43.1213 298.135 43.2093C298.278 43.2974 298.421 43.3245 298.55 43.2771C298.733 43.2093 298.849 43.0806 298.903 42.8706C298.957 42.6674 298.971 42.4302 298.951 42.1593C298.93 41.895 298.89 41.6037 298.815 41.3056C298.747 41.0008 298.686 40.723 298.625 40.4656C298.563 40.2081 298.523 39.9913 298.495 39.8152C298.468 39.6323 298.495 39.5307 298.557 39.5103C298.611 39.49 298.672 39.5307 298.74 39.6323C298.808 39.7339 298.869 39.8694 298.93 40.0388C298.978 40.1743 299.019 40.3097 299.046 40.4588C299.073 40.6011 299.087 40.7366 299.087 40.8585C299.087 40.9804 299.08 41.0888 299.053 41.1837C299.025 41.2785 298.991 41.3531 298.93 41.3937L299.419 42.7622L300.384 42.4167L299.895 41.0482L299.732 41.1092C299.725 41.0075 299.712 40.8856 299.684 40.7433C299.664 40.6011 299.63 40.4385 299.596 40.2623L300.038 40.1065H300.051Z",
    fill: "url(#paint8_linear_150_1314)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.201 40.0456L299.821 38.9887L299.44 39.1242C299.332 38.8126 299.202 38.5213 299.067 38.2503C298.931 37.9793 298.788 37.749 298.639 37.5525C298.496 37.3628 298.346 37.2205 298.204 37.1257C298.061 37.0308 297.918 37.0105 297.789 37.0579C297.613 37.1189 297.497 37.2544 297.449 37.4576C297.402 37.6609 297.381 37.8912 297.402 38.1554C297.422 38.4197 297.463 38.7042 297.531 38.9955C297.599 39.2936 297.66 39.5646 297.714 39.8153C297.769 40.0659 297.81 40.2827 297.83 40.4521C297.85 40.6282 297.83 40.7298 297.762 40.7502C297.721 40.7637 297.667 40.7298 297.599 40.6485C297.531 40.5672 297.463 40.4182 297.388 40.215C297.28 39.9169 297.225 39.6323 297.218 39.3681C297.218 39.1039 297.266 38.9007 297.381 38.7787L296.899 37.4305L295.914 37.7828L296.396 39.131L296.559 39.0768C296.593 39.4291 296.654 39.7678 296.729 40.0795L296.321 40.2285L296.702 41.2854L297.076 41.1499C297.191 41.4615 297.32 41.7528 297.456 42.0238C297.592 42.2948 297.728 42.5319 297.871 42.7216C298.013 42.9181 298.156 43.0603 298.299 43.1484C298.441 43.2365 298.584 43.2636 298.713 43.2162C298.897 43.1484 299.012 43.0197 299.067 42.8097C299.121 42.6064 299.135 42.3693 299.114 42.0983C299.094 41.8341 299.053 41.5428 298.978 41.2447C298.91 40.9399 298.849 40.6621 298.788 40.4047C298.727 40.1472 298.686 39.9304 298.666 39.7543C298.639 39.5714 298.666 39.4697 298.727 39.4494C298.781 39.4291 298.842 39.4697 298.91 39.5714C298.978 39.673 299.039 39.8085 299.101 39.9778C299.148 40.1133 299.189 40.2488 299.216 40.3979C299.243 40.5401 299.257 40.6756 299.257 40.7976C299.257 40.9195 299.25 41.0279 299.223 41.1228C299.196 41.2176 299.162 41.2921 299.101 41.3328L299.59 42.7013L300.555 42.3558L300.065 40.9873L299.902 41.0483C299.896 40.9466 299.882 40.8247 299.855 40.6824C299.834 40.5401 299.8 40.3776 299.766 40.2014L300.208 40.0456H300.201Z",
    fill: "url(#paint9_linear_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M296.39 33.0475C296.07 32.9797 295.764 32.9865 295.486 33.0881L293.794 33.6911C293.556 33.7859 293.345 33.9418 293.169 34.145C291.871 35.1815 291.769 38.4876 293.033 42.0037C294.29 45.5198 296.471 48.0196 298.136 47.9993C298.408 48.04 298.666 48.0332 298.91 47.9519H298.931L298.951 47.9383H298.965L300.602 47.3489C300.888 47.2473 301.125 47.0576 301.329 46.807C302.518 45.6688 302.573 42.4508 301.35 39.0431C300.127 35.6354 298.041 33.1762 296.396 33.0475H296.39Z",
    fill: "url(#paint10_linear_150_1314)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219.146 91.7096C214.37 90.8289 210.184 91.8045 209.797 93.8911C209.41 95.9777 212.97 98.3827 217.74 99.2702C222.517 100.151 226.702 99.1754 227.09 97.0888C227.477 95.0021 223.916 92.5971 219.146 91.7164V91.7096Z",
    fill: "url(#paint11_linear_150_1314)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.278 91.7232C213.017 90.8628 215.993 90.6189 219.235 91.2151C222.476 91.8112 225.173 93.1052 226.485 94.5279L227.674 94.7447L227.3 96.7568V96.7974L227.286 96.8178C226.845 98.9111 222.612 99.8867 217.787 98.9924C212.963 98.105 209.369 95.6864 209.702 93.5727L210.089 91.4928L211.278 91.7096V91.7232Z",
    fill: "url(#paint12_linear_150_1314)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.594 89.2776C214.736 88.3833 210.483 89.3724 210.088 91.4997C209.694 93.6202 213.309 96.0726 218.167 96.9669C223.026 97.8612 227.279 96.872 227.673 94.7448C228.067 92.6243 224.453 90.1718 219.594 89.2776Z",
    fill: "url(#paint13_linear_150_1314)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.468 91.4116C211.149 93.1459 214.227 95.1716 218.358 95.9303C222.482 96.6891 226.09 95.9032 226.417 94.1689C226.736 92.4346 223.658 90.4089 219.527 89.6502C215.402 88.8914 211.794 89.6773 211.468 91.4116Z",
    fill: "url(#paint14_linear_150_1314)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M212.073 91.7775C211.774 93.3763 214.594 95.2394 218.358 95.9304C222.129 96.6282 225.424 95.8965 225.723 94.2977C226.022 92.6989 223.203 90.8358 219.438 90.1448C215.667 89.447 212.372 90.1787 212.073 91.7775Z",
    fill: "url(#paint15_radial_150_1314)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.378 95.8354C214.607 95.1376 211.801 93.2407 212.107 91.5945C212.413 89.9482 215.715 89.1759 219.486 89.8737C223.257 90.5715 226.063 92.4684 225.758 94.1146C225.452 95.7609 222.15 96.5332 218.378 95.8354ZM219.635 89.0743C214.859 88.1935 210.673 89.1691 210.286 91.2557C209.899 93.3423 213.459 95.7474 218.229 96.6281C223.006 97.5088 227.191 96.5332 227.579 94.4466C227.966 92.36 224.405 89.955 219.635 89.0743Z",
    fill: "url(#paint16_linear_150_1314)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.948 91.0187L218.65 90.7816L218.562 91.2491C218.175 91.1813 217.808 91.1339 217.448 91.1136C217.088 91.0933 216.768 91.1 216.483 91.1339C216.204 91.1678 215.973 91.2355 215.79 91.3236C215.606 91.4184 215.504 91.5404 215.477 91.703C215.436 91.9198 215.504 92.1162 215.681 92.2856C215.858 92.455 216.089 92.6108 216.367 92.7463C216.646 92.8818 216.958 93.0037 217.305 93.1121C217.645 93.2205 217.964 93.3154 218.249 93.4102C218.542 93.4983 218.779 93.5864 218.97 93.6677C219.16 93.7489 219.248 93.8302 219.235 93.9115C219.228 93.959 219.16 93.9928 219.031 94.0132C218.902 94.0335 218.718 94.0199 218.467 93.9725C218.1 93.9048 217.781 93.7964 217.502 93.6406C217.223 93.4847 217.06 93.3154 216.992 93.1189L215.328 92.814L215.104 94.0199L216.768 94.3248L216.802 94.1283C217.183 94.2977 217.563 94.44 217.93 94.5484L217.835 95.0497L219.133 95.2868L219.221 94.8261C219.608 94.8871 219.975 94.9345 220.335 94.9548C220.696 94.9819 221.015 94.9752 221.294 94.9481C221.579 94.9142 221.803 94.8532 221.987 94.7652C222.163 94.6703 222.265 94.5484 222.299 94.379C222.34 94.1554 222.272 93.959 222.095 93.7828C221.919 93.6067 221.681 93.4509 221.395 93.3154C221.11 93.1799 220.791 93.0512 220.444 92.9428C220.091 92.8344 219.772 92.7327 219.479 92.6379C219.187 92.543 218.936 92.4617 218.739 92.3805C218.542 92.2992 218.447 92.2179 218.46 92.1366C218.474 92.0688 218.548 92.0349 218.691 92.0282C218.834 92.0214 219.01 92.0282 219.221 92.0688C219.391 92.1027 219.554 92.1433 219.71 92.2043C219.873 92.2585 220.016 92.3263 220.138 92.394C220.261 92.4617 220.369 92.543 220.451 92.6243C220.533 92.7056 220.587 92.7869 220.594 92.8682L222.279 93.1799L222.496 92.0011L220.811 91.6894L220.777 91.8927C220.668 91.8452 220.539 91.7843 220.376 91.7233C220.213 91.6623 220.03 91.5946 219.826 91.5336L219.928 90.9916L219.948 91.0187Z",
    fill: "url(#paint17_linear_150_1314)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.982 90.8289L218.684 90.5918L218.596 91.0592C218.209 90.9915 217.842 90.9441 217.482 90.9238C217.122 90.9034 216.802 90.9102 216.517 90.9441C216.238 90.978 216 91.0457 215.824 91.1338C215.64 91.2286 215.538 91.3506 215.511 91.5132C215.47 91.73 215.538 91.9264 215.715 92.0958C215.892 92.2652 216.123 92.421 216.401 92.5565C216.68 92.692 216.992 92.8139 217.339 92.9223C217.685 93.0307 217.998 93.1255 218.283 93.2204C218.576 93.3085 218.813 93.3965 219.004 93.4778C219.194 93.5591 219.282 93.6404 219.269 93.7217C219.262 93.7691 219.194 93.803 219.065 93.8233C218.936 93.8437 218.752 93.8301 218.501 93.7827C218.134 93.7149 217.815 93.6066 217.536 93.4507C217.257 93.2949 217.094 93.1255 217.026 92.9291L215.362 92.6242L215.137 93.8301L216.802 94.135L216.836 93.9385C217.217 94.1079 217.597 94.2501 217.964 94.3585L217.869 94.8599L219.167 95.097L219.255 94.6363C219.642 94.6973 220.009 94.7447 220.369 94.765C220.73 94.7921 221.049 94.7854 221.327 94.7583C221.613 94.7244 221.837 94.6634 222.021 94.5753C222.197 94.4805 222.299 94.3585 222.333 94.1892C222.374 93.9656 222.306 93.7691 222.129 93.593C221.953 93.4169 221.715 93.261 221.429 93.1255C221.144 92.99 220.825 92.8613 220.478 92.7529C220.125 92.6445 219.805 92.5429 219.513 92.4481C219.221 92.3532 218.97 92.2719 218.773 92.1906C218.576 92.1093 218.48 92.028 218.494 91.9467C218.508 91.879 218.582 91.8451 218.725 91.8316C218.868 91.8248 219.044 91.8316 219.255 91.8722C219.425 91.9061 219.588 91.9467 219.744 92.0077C219.907 92.0619 220.05 92.1297 220.172 92.1974C220.295 92.2652 220.403 92.3465 220.485 92.4277C220.566 92.509 220.621 92.5903 220.628 92.6716L222.313 92.9833L222.53 91.8045L220.845 91.4928L220.804 91.6961C220.696 91.6487 220.566 91.5877 220.403 91.5267C220.24 91.4657 220.057 91.398 219.853 91.337L219.955 90.795L219.982 90.8289Z",
    fill: "url(#paint18_linear_150_1314)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M266.655 169.673C263.978 173.006 263 176.665 264.468 177.83C265.935 179.002 269.292 177.241 271.969 173.907C274.646 170.574 275.625 166.923 274.157 165.751C272.689 164.579 269.333 166.34 266.655 169.673Z",
    fill: "url(#paint19_linear_150_1314)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.387 175.777C263.435 174.07 264.488 171.665 266.302 169.395C268.116 167.133 270.243 165.581 271.901 165.154L272.567 164.321L273.98 165.446L273.994 165.459L274.007 165.473L274.021 165.486C275.468 166.699 274.469 170.391 271.765 173.758C269.067 177.125 265.677 178.914 264.168 177.776L262.708 176.611L263.373 175.777H263.387Z",
    fill: "url(#paint20_linear_150_1314)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.95 168.311C262.232 171.706 261.233 175.418 262.721 176.61C264.209 177.796 267.627 176.014 270.345 172.62C273.063 169.226 274.062 165.513 272.567 164.328C271.072 163.136 267.661 164.924 264.943 168.318L264.95 168.311Z",
    fill: "url(#paint21_linear_150_1314)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M263.224 175.499C264.44 176.468 267.308 174.924 269.618 172.038C271.928 169.158 272.818 166.028 271.595 165.06C270.379 164.091 267.512 165.635 265.201 168.521C262.891 171.408 262.001 174.531 263.224 175.499Z",
    fill: "url(#paint22_linear_150_1314)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M263.761 175.188C264.882 176.082 267.505 174.673 269.618 172.044C271.731 169.409 272.533 166.55 271.405 165.656C270.284 164.761 267.661 166.171 265.548 168.799C263.434 171.435 262.633 174.294 263.761 175.188Z",
    fill: "url(#paint23_radial_150_1314)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M269.556 171.983C267.443 174.619 264.793 176.001 263.638 175.079C262.483 174.158 263.251 171.272 265.364 168.637C267.477 166.001 270.127 164.619 271.282 165.541C272.437 166.462 271.67 169.348 269.556 171.977V171.983ZM264.807 168.196C262.13 171.529 261.151 175.188 262.619 176.353C264.087 177.525 267.443 175.764 270.12 172.43C272.797 169.097 273.776 165.446 272.308 164.274C270.841 163.102 267.484 164.863 264.807 168.196Z",
    fill: "url(#paint24_linear_150_1314)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M266.452 168.759L265.725 169.666L266.058 169.931C265.84 170.202 265.657 170.466 265.487 170.737C265.324 171.008 265.195 171.258 265.106 171.496C265.018 171.726 264.97 171.936 264.97 172.112C264.97 172.288 265.025 172.424 265.134 172.512C265.29 172.634 265.466 172.661 265.677 172.593C265.881 172.525 266.098 172.41 266.323 172.254C266.547 172.092 266.771 171.902 266.995 171.678C267.22 171.455 267.43 171.252 267.62 171.069C267.811 170.879 267.981 170.73 268.123 170.615C268.266 170.5 268.368 170.466 268.422 170.506C268.456 170.534 268.456 170.601 268.422 170.703C268.388 170.811 268.3 170.947 268.157 171.123C267.953 171.38 267.729 171.584 267.498 171.733C267.267 171.882 267.056 171.943 266.88 171.909L265.949 173.074L266.798 173.752L267.729 172.586L267.593 172.478C267.885 172.254 268.15 172.017 268.388 171.78L268.742 172.065L269.469 171.157L269.149 170.899C269.36 170.628 269.55 170.357 269.713 170.093C269.883 169.829 270.012 169.578 270.107 169.348C270.202 169.118 270.25 168.914 270.25 168.738C270.25 168.562 270.196 168.427 270.08 168.339C269.924 168.217 269.74 168.183 269.53 168.25C269.319 168.318 269.102 168.433 268.871 168.596C268.646 168.759 268.415 168.955 268.184 169.179C267.953 169.402 267.743 169.612 267.546 169.802C267.349 169.992 267.179 170.147 267.036 170.269C266.893 170.391 266.791 170.425 266.73 170.384C266.683 170.351 266.69 170.276 266.737 170.161C266.791 170.046 266.873 169.917 266.989 169.768C267.084 169.653 267.186 169.544 267.294 169.443C267.403 169.341 267.518 169.26 267.627 169.185C267.736 169.118 267.838 169.07 267.94 169.036C268.042 169.002 268.123 169.002 268.191 169.03L269.136 167.851L268.307 167.187L267.362 168.366L267.505 168.481C267.423 168.542 267.321 168.623 267.206 168.718C267.09 168.813 266.961 168.928 266.825 169.063L266.445 168.759H266.452Z",
    fill: "url(#paint25_linear_150_1314)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M266.315 168.657L265.588 169.565L265.921 169.829C265.704 170.1 265.52 170.364 265.351 170.635C265.188 170.906 265.058 171.157 264.97 171.394C264.882 171.624 264.834 171.834 264.834 172.01C264.834 172.187 264.889 172.322 264.997 172.41C265.154 172.532 265.33 172.559 265.541 172.491C265.745 172.424 265.962 172.309 266.186 172.153C266.411 171.99 266.635 171.8 266.859 171.577C267.083 171.353 267.294 171.15 267.484 170.967C267.674 170.777 267.844 170.628 267.987 170.513C268.13 170.398 268.232 170.364 268.286 170.405C268.32 170.432 268.32 170.5 268.286 170.601C268.252 170.71 268.164 170.845 268.021 171.021C267.817 171.279 267.593 171.482 267.362 171.631C267.131 171.78 266.92 171.841 266.744 171.807L265.813 172.972L266.662 173.65L267.593 172.485L267.457 172.376C267.749 172.153 268.014 171.916 268.252 171.678L268.605 171.963L269.332 171.055L269.013 170.798C269.224 170.527 269.414 170.256 269.577 169.992C269.747 169.727 269.876 169.477 269.971 169.246C270.066 169.016 270.114 168.813 270.114 168.637C270.114 168.46 270.059 168.325 269.944 168.237C269.788 168.115 269.604 168.081 269.394 168.149C269.183 168.217 268.965 168.332 268.734 168.494C268.51 168.657 268.279 168.853 268.048 169.077C267.817 169.301 267.606 169.511 267.409 169.7C267.212 169.89 267.043 170.046 266.9 170.168C266.757 170.29 266.655 170.324 266.594 170.283C266.547 170.249 266.553 170.174 266.601 170.059C266.655 169.944 266.737 169.815 266.852 169.666C266.947 169.551 267.049 169.443 267.158 169.341C267.274 169.24 267.382 169.158 267.491 169.084C267.6 169.016 267.702 168.969 267.804 168.935C267.905 168.901 267.987 168.901 268.055 168.928L268.999 167.749L268.17 167.085L267.226 168.264L267.369 168.379C267.287 168.44 267.185 168.521 267.07 168.616C266.954 168.711 266.825 168.826 266.689 168.962L266.309 168.657H266.315Z",
    fill: "url(#paint26_linear_150_1314)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M274.388 56.874C272.526 53.2021 268.626 50.9326 264.753 51.5762C260.085 52.3485 257.217 57.0637 258.352 62.1109C258.542 62.9713 258.841 63.7842 259.229 64.543C261.091 68.2149 264.991 70.4844 268.864 69.8408C273.532 69.0685 276.399 64.3533 275.264 59.3061C275.074 58.4458 274.775 57.6328 274.388 56.874Z",
    fill: "url(#paint27_linear_150_1314)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M272.003 68.6485L271.975 68.6011C274.775 66.7312 276.229 63.0864 275.366 59.2519C275.176 58.3916 274.877 57.5786 274.489 56.8198C272.628 53.1479 268.728 50.8784 264.855 51.522C264.379 51.6033 263.917 51.7252 263.482 51.881L263.455 51.8268L262.538 52.2943C259.29 53.9948 257.523 57.9105 258.454 62.0567C258.644 62.9171 258.943 63.73 259.33 64.4888C261.192 68.1607 265.092 70.4302 268.965 69.7866C269.74 69.6579 270.46 69.4208 271.126 69.0889L271.996 68.6485H272.003Z",
    fill: "url(#paint28_linear_150_1314)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M275.407 56.3591C273.545 52.6872 269.645 50.4177 265.772 51.0613C261.104 51.8336 258.236 56.5488 259.371 61.596C259.561 62.4564 259.86 63.2693 260.248 64.0281C262.109 67.7 266.009 69.9696 269.882 69.326C274.55 68.5536 277.418 63.8384 276.283 58.7913C276.093 57.9309 275.794 57.1179 275.407 56.3591Z",
    fill: "url(#paint29_linear_150_1314)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M274.089 57.0162C273.389 55.6341 272.302 54.435 270.902 53.6356C267.403 51.6303 263.285 52.8971 261.702 56.4539C260.751 58.5879 260.934 61.0675 261.987 63.1405C262.687 64.5226 263.774 65.7217 265.174 66.5211C268.673 68.5197 272.791 67.2596 274.374 63.7028C275.325 61.5688 275.142 59.0892 274.096 57.0162H274.089Z",
    fill: "url(#paint30_linear_150_1314)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M273.755 57.0908C273.062 55.7291 271.989 54.5435 270.616 53.7577C267.165 51.7862 263.101 53.026 261.538 56.5353C260.601 58.6423 260.777 61.0879 261.817 63.1339C262.51 64.4956 263.584 65.6812 264.963 66.4671C268.415 68.4385 272.478 67.1987 274.034 63.6894C274.972 61.5825 274.795 59.1368 273.755 57.0976V57.0908Z",
    fill: "url(#paint31_radial_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M273.755 57.0908C273.062 55.7291 271.989 54.5435 270.616 53.7577C267.165 51.7862 263.101 53.026 261.538 56.5353C260.601 58.6423 260.777 61.0879 261.817 63.1339C262.51 64.4956 263.584 65.6812 264.963 66.4671C268.415 68.4385 272.478 67.1987 274.034 63.6894C274.972 61.5825 274.795 59.1368 273.755 57.0976V57.0908Z",
    fill: "url(#paint32_radial_150_1314)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M262.11 63.0796C261.811 62.4902 261.573 61.8466 261.423 61.1759C260.533 57.2262 262.782 53.5272 266.438 52.9243C269.468 52.4229 272.526 54.1979 273.987 57.0772C274.286 57.6666 274.524 58.3102 274.673 58.9809C275.563 62.9305 273.314 66.6295 269.659 67.2325C266.621 67.7338 263.571 65.9588 262.11 63.0796ZM275.577 56.271C273.729 52.6262 269.856 50.3702 266.01 51.007C261.376 51.7726 258.529 56.4607 259.657 61.4604C259.847 62.314 260.146 63.127 260.527 63.8722C262.375 67.517 266.248 69.7662 270.087 69.1294C274.721 68.3571 277.568 63.6758 276.44 58.676C276.25 57.8224 275.951 57.0162 275.57 56.2642L275.577 56.271Z",
    fill: "url(#paint33_linear_150_1314)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M272.444 58.7235L271.398 58.8928C271.309 58.5067 271.18 58.1476 271.01 57.8156L270.983 57.7682C270.8 57.4159 270.582 57.1178 270.331 56.8672C270.08 56.6165 269.801 56.4336 269.495 56.3116C269.189 56.1897 268.856 56.1626 268.496 56.2168C268.014 56.2981 267.647 56.4675 267.396 56.7317C267.144 56.9959 266.968 57.294 266.852 57.6327C266.736 57.9715 266.675 58.3373 266.662 58.7167C266.648 59.1028 266.641 59.4551 266.628 59.7735C266.614 60.0919 266.587 60.3765 266.539 60.6001C266.485 60.8304 266.37 60.9523 266.193 60.9862C266.084 61.0065 265.969 60.9591 265.853 60.8507C265.799 60.7965 265.744 60.7288 265.704 60.6475C265.656 60.5526 265.615 60.4307 265.581 60.2952C265.493 59.909 265.527 59.5432 265.677 59.1977C265.826 58.8522 266.084 58.5947 266.451 58.4389L266.057 56.691L263.373 57.1382L263.767 58.886L264.202 58.8115C264.08 59.2654 264.019 59.699 264.019 60.1123L262.897 60.2952L263.203 61.6569L264.222 61.4875C264.331 61.8872 264.467 62.2666 264.644 62.6189C264.651 62.6392 264.664 62.6596 264.671 62.6799C264.834 63.0051 265.031 63.2896 265.262 63.52C265.5 63.7706 265.778 63.9535 266.077 64.0755C266.383 64.1974 266.716 64.2245 267.076 64.1636C267.572 64.0823 267.946 63.9061 268.197 63.6419C268.456 63.3777 268.639 63.0728 268.748 62.7273C268.856 62.3818 268.924 62.016 268.931 61.623C268.945 61.2301 268.958 60.871 268.965 60.5459C268.979 60.2139 269.006 59.9361 269.047 59.7058C269.094 59.4754 269.203 59.34 269.38 59.3129C269.522 59.2858 269.651 59.34 269.76 59.4754C269.808 59.5296 269.842 59.5906 269.876 59.6584C269.923 59.76 269.964 59.8684 269.998 60.0039C270.039 60.18 270.046 60.3562 270.025 60.5459C270.005 60.7288 269.957 60.8981 269.889 61.0607C269.821 61.2165 269.726 61.3588 269.604 61.4808C269.482 61.6027 269.339 61.6976 269.176 61.7518L269.57 63.52L272.193 63.0864L271.799 61.3182L271.35 61.3927C271.391 61.264 271.425 61.1082 271.459 60.9252C271.493 60.7355 271.513 60.5323 271.52 60.302L272.723 60.1055L272.417 58.7438L272.444 58.7235Z",
    fill: "url(#paint34_linear_150_1314)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M272.662 58.6083L271.615 58.7777C271.527 58.3915 271.398 58.0325 271.228 57.7005L271.201 57.6531C271.017 57.3008 270.8 57.0027 270.548 56.7521C270.297 56.5014 270.018 56.3185 269.713 56.1965C269.407 56.0746 269.074 56.0475 268.714 56.1017C268.231 56.183 267.865 56.3524 267.613 56.6166C267.362 56.8808 267.185 57.1789 267.07 57.5176C266.954 57.8563 266.893 58.2222 266.879 58.6016C266.866 58.9877 266.859 59.34 266.845 59.6584C266.839 59.9836 266.805 60.2614 266.757 60.4849C266.703 60.7153 266.587 60.8372 266.41 60.8711C266.302 60.8914 266.186 60.844 266.071 60.7356C266.016 60.6814 265.962 60.6137 265.921 60.5324C265.874 60.4375 265.833 60.3156 265.799 60.1801C265.711 59.7939 265.745 59.4281 265.894 59.0826C266.044 58.7371 266.302 58.4796 266.669 58.3238L266.275 56.5759L263.591 57.0231L263.985 58.7709L264.42 58.6964C264.297 59.1503 264.236 59.5839 264.236 59.9972L263.115 60.1801L263.421 61.5418L264.44 61.3724C264.549 61.7721 264.685 62.1515 264.861 62.5038C264.868 62.5241 264.882 62.5445 264.888 62.5648C265.051 62.89 265.249 63.1745 265.48 63.4048C265.717 63.6555 265.996 63.8384 266.295 63.9604C266.601 64.0823 266.934 64.1094 267.294 64.0484C267.79 63.9672 268.163 63.791 268.415 63.5268C268.673 63.2626 268.857 62.9577 268.965 62.6122C269.074 62.2667 269.142 61.9009 269.149 61.5079C269.162 61.115 269.176 60.7559 269.183 60.4307C269.196 60.0988 269.223 59.821 269.264 59.5907C269.312 59.3603 269.421 59.2248 269.597 59.1977C269.74 59.1706 269.869 59.2248 269.978 59.3603C270.025 59.4145 270.059 59.4755 270.093 59.5433C270.141 59.6449 270.182 59.7533 270.209 59.8888C270.249 60.0649 270.256 60.2411 270.236 60.4307C270.216 60.6137 270.168 60.783 270.1 60.9456C270.032 61.1014 269.937 61.2437 269.815 61.3657C269.692 61.4876 269.55 61.5824 269.387 61.6366L269.781 63.4048L272.403 62.9713L272.009 61.2031L271.561 61.2776C271.602 61.1489 271.636 60.993 271.67 60.8101C271.704 60.6204 271.724 60.4172 271.731 60.1869L272.933 59.9904L272.628 58.6287L272.662 58.6083Z",
    fill: "url(#paint35_linear_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M265.778 51.0544C264.943 51.1967 264.168 51.4609 263.461 51.8268L262.544 52.2874C259.228 53.954 257.414 57.9172 258.359 62.0973C258.549 62.9576 258.848 63.7706 259.235 64.5294C261.097 68.2013 264.997 70.4708 268.87 69.8272C269.679 69.6917 270.433 69.4411 271.119 69.0888H271.14L272.009 68.6416C272.75 68.2826 273.416 67.8151 273.993 67.2528C276.168 65.2746 277.214 62.0498 276.453 58.6828C276.263 57.8292 275.964 57.023 275.583 56.271C273.735 52.6262 269.862 50.3702 266.016 51.007C265.942 51.0206 265.86 51.0341 265.785 51.0544H265.778Z",
    fill: "url(#paint36_linear_150_1314)"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M235.664 127.975C234.081 124.865 230.779 122.934 227.497 123.483C223.542 124.14 221.11 128.137 222.068 132.412C222.231 133.144 222.482 133.835 222.809 134.472C224.392 137.581 227.694 139.505 230.976 138.963C234.937 138.306 237.363 134.309 236.405 130.034C236.242 129.302 235.99 128.611 235.664 127.975Z",
    fill: "url(#paint37_linear_150_1314)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M233.647 137.961L233.626 137.92C235.997 136.335 237.234 133.245 236.5 129.994C236.337 129.262 236.086 128.571 235.76 127.934C234.177 124.824 230.874 122.894 227.592 123.442C227.185 123.51 226.797 123.612 226.43 123.747L226.41 123.7L225.629 124.093C222.877 125.536 221.375 128.855 222.17 132.365C222.333 133.096 222.585 133.787 222.911 134.424C224.494 137.534 227.796 139.458 231.078 138.916C231.737 138.807 232.349 138.604 232.913 138.326L233.653 137.954L233.647 137.961Z",
    fill: "url(#paint38_linear_150_1314)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M236.534 127.534C234.951 124.425 231.649 122.494 228.367 123.043C224.413 123.7 221.98 127.697 222.938 131.972C223.101 132.703 223.353 133.394 223.679 134.031C225.262 137.141 228.564 139.065 231.846 138.523C235.807 137.866 238.233 133.869 237.275 129.594C237.112 128.862 236.861 128.171 236.534 127.534Z",
    fill: "url(#paint39_linear_150_1314)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M235.413 128.097C234.822 126.925 233.898 125.908 232.709 125.231C229.739 123.531 226.247 124.601 224.908 127.622C224.1 129.431 224.256 131.538 225.146 133.293C225.737 134.465 226.661 135.481 227.85 136.159C230.813 137.852 234.312 136.789 235.651 133.767C236.459 131.958 236.303 129.858 235.413 128.097Z",
    fill: "url(#paint40_linear_150_1314)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M235.134 128.158C234.55 127.006 233.64 126.003 232.471 125.332C229.542 123.659 226.097 124.716 224.779 127.69C223.984 129.479 224.134 131.552 225.017 133.279C225.601 134.431 226.512 135.434 227.681 136.104C230.602 137.778 234.054 136.721 235.372 133.747C236.167 131.958 236.018 129.885 235.134 128.158Z",
    fill: "url(#paint41_radial_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M235.134 128.158C234.55 127.006 233.64 126.003 232.471 125.332C229.542 123.659 226.097 124.716 224.779 127.69C223.984 129.479 224.134 131.552 225.017 133.279C225.601 134.431 226.512 135.434 227.681 136.104C230.602 137.778 234.054 136.721 235.372 133.747C236.167 131.958 236.018 129.885 235.134 128.158Z",
    fill: "url(#paint42_radial_150_1314)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M225.262 133.239C225.004 132.737 224.807 132.195 224.678 131.626C223.924 128.279 225.826 125.143 228.931 124.628C231.506 124.201 234.089 125.712 235.332 128.151C235.59 128.652 235.787 129.194 235.909 129.763C236.664 133.11 234.761 136.247 231.656 136.761C229.081 137.188 226.492 135.677 225.255 133.239H225.262ZM236.677 127.467C235.108 124.377 231.826 122.467 228.571 123.009C224.644 123.659 222.232 127.629 223.183 131.877C223.346 132.602 223.597 133.286 223.917 133.923C225.486 137.012 228.768 138.923 232.023 138.381C235.95 137.73 238.362 133.76 237.411 129.512C237.248 128.788 236.997 128.103 236.677 127.467Z",
    fill: "url(#paint43_linear_150_1314)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M234.02 129.54L233.137 129.689C233.062 129.364 232.953 129.059 232.811 128.774L232.79 128.733C232.634 128.435 232.451 128.185 232.24 127.975C232.029 127.765 231.791 127.609 231.533 127.507C231.268 127.406 230.99 127.379 230.691 127.426C230.283 127.494 229.97 127.636 229.76 127.86C229.549 128.083 229.393 128.334 229.305 128.625C229.209 128.916 229.155 129.221 229.142 129.546C229.128 129.872 229.121 130.17 229.114 130.447C229.108 130.725 229.08 130.956 229.04 131.145C228.992 131.335 228.897 131.443 228.747 131.47C228.659 131.484 228.557 131.45 228.455 131.355C228.408 131.315 228.367 131.254 228.326 131.179C228.285 131.098 228.251 130.996 228.224 130.881C228.149 130.556 228.177 130.244 228.306 129.953C228.435 129.662 228.652 129.445 228.965 129.309L228.632 127.826L226.356 128.205L226.689 129.689L227.056 129.628C226.947 130.014 226.899 130.38 226.899 130.732L225.948 130.888L226.206 132.04L227.069 131.897C227.157 132.236 227.28 132.554 227.422 132.853C227.429 132.873 227.436 132.886 227.45 132.907C227.592 133.184 227.755 133.422 227.946 133.618C228.149 133.828 228.381 133.984 228.639 134.086C228.897 134.187 229.182 134.214 229.488 134.16C229.909 134.092 230.222 133.943 230.439 133.72C230.657 133.496 230.813 133.239 230.908 132.941C231.003 132.649 231.058 132.338 231.064 132.006C231.078 131.674 231.085 131.369 231.092 131.091C231.098 130.813 231.126 130.576 231.16 130.373C231.2 130.176 231.295 130.068 231.445 130.041C231.567 130.021 231.676 130.068 231.764 130.176C231.805 130.224 231.832 130.271 231.866 130.332C231.907 130.414 231.941 130.515 231.968 130.624C232.002 130.773 232.009 130.922 231.989 131.078C231.968 131.233 231.934 131.376 231.873 131.511C231.812 131.647 231.737 131.762 231.628 131.87C231.526 131.979 231.404 132.053 231.268 132.101L231.608 133.598L233.83 133.232L233.49 131.735L233.11 131.796C233.144 131.687 233.178 131.552 233.205 131.396C233.232 131.24 233.252 131.064 233.259 130.868L234.278 130.698L234.02 129.546V129.54Z",
    fill: "url(#paint44_linear_150_1314)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M234.203 129.445L233.32 129.594C233.245 129.269 233.136 128.964 232.994 128.679L232.973 128.639C232.817 128.34 232.634 128.09 232.423 127.88C232.212 127.67 231.975 127.514 231.716 127.412C231.451 127.311 231.173 127.284 230.874 127.331C230.466 127.399 230.154 127.541 229.943 127.765C229.732 127.988 229.576 128.239 229.488 128.53C229.393 128.821 229.338 129.126 229.325 129.451C229.311 129.777 229.304 130.075 229.297 130.353C229.291 130.63 229.263 130.861 229.223 131.05C229.175 131.24 229.08 131.348 228.931 131.375C228.842 131.389 228.74 131.355 228.638 131.26C228.591 131.22 228.55 131.159 228.509 131.084C228.468 131.003 228.435 130.901 228.407 130.786C228.333 130.461 228.36 130.149 228.489 129.858C228.618 129.567 228.835 129.35 229.148 129.214L228.815 127.731L226.539 128.11L226.872 129.594L227.239 129.533C227.13 129.919 227.082 130.285 227.082 130.637L226.131 130.793L226.389 131.945L227.252 131.802C227.341 132.141 227.463 132.459 227.606 132.758C227.612 132.778 227.619 132.791 227.633 132.812C227.775 133.09 227.939 133.327 228.129 133.523C228.333 133.733 228.564 133.889 228.822 133.991C229.08 134.092 229.365 134.119 229.671 134.065C230.092 133.997 230.405 133.848 230.622 133.625C230.84 133.401 230.996 133.144 231.091 132.846C231.186 132.554 231.241 132.243 231.248 131.911C231.261 131.579 231.268 131.274 231.275 130.996C231.282 130.718 231.309 130.481 231.343 130.278C231.383 130.082 231.479 129.973 231.628 129.946C231.75 129.926 231.859 129.973 231.947 130.082C231.988 130.129 232.015 130.176 232.049 130.237C232.09 130.319 232.124 130.42 232.151 130.529C232.185 130.678 232.192 130.827 232.172 130.983C232.151 131.138 232.117 131.281 232.056 131.416C231.995 131.552 231.92 131.667 231.812 131.775C231.71 131.884 231.587 131.958 231.451 132.006L231.791 133.503L234.013 133.137L233.673 131.64L233.293 131.701C233.327 131.592 233.361 131.457 233.388 131.301C233.415 131.145 233.435 130.969 233.442 130.773L234.461 130.603L234.203 129.451V129.445Z",
    fill: "url(#paint45_linear_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M228.367 123.043C227.66 123.158 227.001 123.388 226.403 123.7L225.621 124.093C222.815 125.509 221.273 128.862 222.068 132.412C222.231 133.144 222.482 133.835 222.808 134.472C224.392 137.581 227.694 139.505 230.976 138.963C231.662 138.848 232.301 138.631 232.885 138.333H232.899L233.639 137.954C234.264 137.649 234.828 137.249 235.318 136.775C237.159 135.095 238.049 132.365 237.404 129.506C237.24 128.781 236.989 128.097 236.67 127.46C235.1 124.371 231.818 122.46 228.564 123.002C228.496 123.016 228.434 123.029 228.367 123.043Z",
    fill: "url(#paint46_linear_150_1314)"
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M317.738 156.984C316.155 153.875 312.853 151.944 309.571 152.492C305.616 153.15 303.184 157.147 304.142 161.422C304.305 162.153 304.556 162.844 304.883 163.481C306.466 166.591 309.768 168.515 313.05 167.973C317.011 167.316 319.437 163.318 318.479 159.044C318.316 158.312 318.064 157.621 317.738 156.984Z",
    fill: "url(#paint47_linear_150_1314)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M315.714 166.97L315.693 166.929C318.065 165.344 319.301 162.255 318.567 159.003C318.404 158.271 318.153 157.58 317.827 156.943C316.244 153.834 312.941 151.903 309.66 152.452C309.252 152.52 308.865 152.621 308.498 152.757L308.477 152.709L307.696 153.102C304.944 154.545 303.442 157.865 304.237 161.374C304.4 162.106 304.652 162.797 304.978 163.434C306.561 166.543 309.863 168.467 313.145 167.925C313.804 167.817 314.416 167.614 314.98 167.336L315.72 166.963L315.714 166.97Z",
    fill: "url(#paint48_linear_150_1314)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M318.601 156.55C317.018 153.441 313.716 151.51 310.434 152.059C306.479 152.716 304.047 156.713 305.005 160.988C305.168 161.72 305.42 162.411 305.746 163.047C307.329 166.157 310.631 168.081 313.913 167.539C317.874 166.882 320.3 162.885 319.342 158.61C319.179 157.878 318.927 157.187 318.601 156.55Z",
    fill: "url(#paint49_linear_150_1314)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M317.487 157.106C316.895 155.934 315.971 154.918 314.782 154.24C311.813 152.54 308.321 153.61 306.982 156.632C306.173 158.441 306.33 160.548 307.22 162.302C307.811 163.474 308.735 164.49 309.924 165.168C312.887 166.862 316.386 165.798 317.724 162.776C318.533 160.968 318.377 158.867 317.487 157.106Z",
    fill: "url(#paint50_linear_150_1314)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M317.208 157.167C316.624 156.015 315.713 155.013 314.545 154.342C311.616 152.669 308.171 153.725 306.853 156.7C306.058 158.488 306.208 160.561 307.091 162.289C307.675 163.44 308.586 164.443 309.754 165.114C312.676 166.787 316.121 165.73 317.446 162.756C318.241 160.968 318.092 158.895 317.208 157.167Z",
    fill: "url(#paint51_radial_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M317.208 157.167C316.624 156.015 315.713 155.013 314.545 154.342C311.616 152.669 308.171 153.725 306.853 156.7C306.058 158.488 306.208 160.561 307.091 162.289C307.675 163.44 308.586 164.443 309.754 165.114C312.676 166.787 316.121 165.73 317.446 162.756C318.241 160.968 318.092 158.895 317.208 157.167Z",
    fill: "url(#paint52_radial_150_1314)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M307.328 162.248C307.07 161.747 306.873 161.205 306.744 160.636C305.99 157.289 307.892 154.152 310.997 153.637C313.573 153.211 316.155 154.721 317.398 157.16C317.656 157.662 317.853 158.204 317.976 158.773C318.73 162.119 316.827 165.256 313.722 165.771C311.147 166.198 308.558 164.687 307.321 162.248H307.328ZM318.743 156.476C317.174 153.387 313.892 151.476 310.637 152.018C306.71 152.669 304.298 156.639 305.249 160.886C305.412 161.611 305.664 162.295 305.983 162.932C307.553 166.022 310.834 167.932 314.089 167.39C318.016 166.74 320.429 162.77 319.477 158.522C319.314 157.797 319.063 157.113 318.743 156.476Z",
    fill: "url(#paint53_linear_150_1314)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M316.087 158.549L315.204 158.698C315.129 158.373 315.02 158.068 314.878 157.783L314.857 157.743C314.701 157.445 314.518 157.194 314.307 156.984C314.096 156.774 313.859 156.618 313.6 156.517C313.335 156.415 313.057 156.388 312.758 156.435C312.35 156.503 312.038 156.645 311.827 156.869C311.616 157.092 311.46 157.343 311.365 157.634C311.27 157.926 311.215 158.231 311.202 158.556C311.188 158.881 311.181 159.179 311.175 159.457C311.168 159.735 311.141 159.965 311.1 160.155C311.052 160.344 310.957 160.453 310.808 160.48C310.719 160.493 310.617 160.459 310.516 160.365C310.468 160.324 310.427 160.263 310.386 160.188C310.346 160.107 310.312 160.006 310.285 159.89C310.21 159.565 310.237 159.254 310.366 158.962C310.495 158.671 310.713 158.454 311.025 158.319L310.692 156.835L308.416 157.214L308.749 158.698L309.116 158.637C309.007 159.023 308.96 159.389 308.96 159.741L308.008 159.897L308.266 161.049L309.129 160.907C309.218 161.245 309.34 161.564 309.483 161.862C309.49 161.882 309.496 161.896 309.51 161.916C309.653 162.194 309.816 162.431 310.006 162.627C310.21 162.837 310.441 162.993 310.699 163.095C310.957 163.196 311.243 163.224 311.548 163.169C311.97 163.102 312.282 162.953 312.5 162.729C312.717 162.505 312.873 162.248 312.968 161.95C313.064 161.659 313.118 161.347 313.125 161.015C313.138 160.683 313.145 160.378 313.152 160.1C313.159 159.823 313.186 159.586 313.22 159.382C313.261 159.186 313.356 159.077 313.505 159.05C313.628 159.03 313.736 159.077 313.825 159.186C313.865 159.233 313.893 159.281 313.927 159.342C313.967 159.423 314.001 159.525 314.028 159.633C314.062 159.782 314.069 159.931 314.049 160.087C314.028 160.243 313.994 160.385 313.933 160.52C313.872 160.656 313.797 160.771 313.696 160.88C313.594 160.988 313.471 161.062 313.335 161.11L313.675 162.607L315.897 162.241L315.557 160.744L315.177 160.805C315.211 160.697 315.245 160.561 315.272 160.405C315.299 160.249 315.319 160.073 315.326 159.877L316.345 159.707L316.087 158.556V158.549Z",
    fill: "url(#paint54_linear_150_1314)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M316.277 158.454L315.394 158.603C315.319 158.278 315.21 157.973 315.068 157.689L315.047 157.648C314.891 157.35 314.708 157.099 314.497 156.889C314.286 156.679 314.049 156.523 313.79 156.422C313.525 156.32 313.247 156.293 312.948 156.341C312.54 156.408 312.228 156.551 312.017 156.774C311.806 156.998 311.65 157.248 311.562 157.54C311.467 157.831 311.412 158.136 311.399 158.461C311.385 158.786 311.378 159.084 311.371 159.362C311.365 159.64 311.337 159.87 311.297 160.06C311.249 160.25 311.154 160.358 311.005 160.385C310.916 160.399 310.814 160.365 310.712 160.27C310.665 160.229 310.624 160.168 310.583 160.094C310.542 160.012 310.509 159.911 310.481 159.796C310.407 159.47 310.434 159.159 310.563 158.867C310.692 158.576 310.909 158.359 311.222 158.224L310.889 156.74L308.613 157.12L308.946 158.603L309.313 158.542C309.204 158.928 309.156 159.294 309.156 159.647L308.205 159.802L308.463 160.954L309.326 160.812C309.415 161.151 309.537 161.469 309.68 161.767L309.707 161.821C309.849 162.099 310.012 162.336 310.203 162.533C310.407 162.743 310.638 162.898 310.896 163C311.154 163.102 311.439 163.129 311.745 163.075C312.166 163.007 312.479 162.858 312.696 162.634C312.914 162.411 313.07 162.153 313.165 161.855C313.26 161.564 313.315 161.252 313.322 160.92C313.335 160.588 313.342 160.283 313.349 160.006C313.356 159.728 313.383 159.491 313.417 159.288C313.457 159.091 313.553 158.983 313.702 158.956C313.824 158.935 313.933 158.983 314.021 159.091C314.062 159.138 314.089 159.186 314.123 159.247C314.164 159.328 314.198 159.43 314.225 159.538C314.259 159.687 314.266 159.836 314.246 159.992C314.225 160.148 314.191 160.29 314.13 160.426C314.069 160.561 313.994 160.676 313.892 160.785C313.79 160.893 313.668 160.968 313.532 161.015L313.872 162.512L316.094 162.146L315.754 160.649L315.374 160.71C315.408 160.602 315.441 160.466 315.469 160.31C315.496 160.155 315.516 159.979 315.523 159.782L316.542 159.613L316.284 158.461L316.277 158.454Z",
    fill: "url(#paint55_linear_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M310.44 152.052C309.734 152.167 309.075 152.398 308.477 152.709L307.695 153.102C304.889 154.518 303.347 157.872 304.142 161.422C304.305 162.153 304.556 162.844 304.882 163.481C306.466 166.591 309.768 168.515 313.05 167.973C313.736 167.858 314.375 167.641 314.959 167.343H314.973L315.713 166.963C316.338 166.658 316.902 166.259 317.392 165.784C319.233 164.104 320.123 161.374 319.478 158.515C319.314 157.79 319.063 157.106 318.744 156.469C317.174 153.38 313.892 151.469 310.638 152.011C310.57 152.025 310.508 152.039 310.44 152.052Z",
    fill: "url(#paint56_linear_150_1314)"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M207.534 49.4894C208.248 50.7224 209.26 51.7996 210.476 52.5245C213.527 54.3401 216.741 53.2697 217.652 50.1262C218.195 48.2428 217.788 46.041 216.721 44.1848C216.007 42.9518 214.995 41.8746 213.779 41.1497C210.728 39.3341 207.514 40.4045 206.61 43.5479C206.067 45.4313 206.468 47.6331 207.541 49.4894H207.534Z",
    fill: "url(#paint57_linear_150_1314)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M208.445 40.7975L207.432 41.3801L207.507 41.5156C206.984 42.0508 206.569 42.7486 206.325 43.5954C205.767 45.5127 206.182 47.7551 207.276 49.6385C208.003 50.8918 209.029 51.9893 210.272 52.7278C211.713 53.5814 213.181 53.8117 214.444 53.4865L214.526 53.622L215.498 53.0597C216.456 52.5042 217.203 51.5625 217.577 50.2889C218.134 48.3716 217.719 46.1292 216.625 44.2458C215.898 42.9925 214.872 41.895 213.629 41.1565C211.781 40.059 209.878 39.998 208.445 40.8042V40.7975Z",
    fill: "url(#paint58_linear_150_1314)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M206.304 50.194C207.032 51.4473 208.058 52.5448 209.301 53.2833C212.406 55.1328 215.674 54.042 216.599 50.8444C217.156 48.9271 216.741 46.6847 215.647 44.8013C214.92 43.548 213.894 42.4505 212.651 41.712C209.546 39.8625 206.277 40.9533 205.353 44.1509C204.796 46.0682 205.211 48.3106 206.304 50.194Z",
    fill: "url(#paint59_linear_150_1314)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M206.95 49.8214C207.527 50.8173 208.336 51.6844 209.321 52.2671C211.781 53.7304 214.37 52.87 215.103 50.3363C215.545 48.8187 215.219 47.0437 214.349 45.5465C213.772 44.5506 212.963 43.6835 211.978 43.1009C209.518 41.6375 206.929 42.4979 206.196 45.0317C205.754 46.5492 206.08 48.3242 206.95 49.8214Z",
    fill: "url(#paint60_linear_150_1314)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M207.33 49.6046C207.901 50.5869 208.703 51.4405 209.668 52.0164C212.094 53.4594 214.648 52.6058 215.369 50.1127C215.803 48.6154 215.477 46.8608 214.628 45.3907C214.057 44.4083 213.255 43.5547 212.291 42.9789C209.865 41.5359 207.31 42.3895 206.59 44.8826C206.155 46.3798 206.481 48.1344 207.33 49.6046Z",
    fill: "url(#paint61_radial_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M207.33 49.6046C207.901 50.5869 208.703 51.4405 209.668 52.0164C212.094 53.4594 214.648 52.6058 215.369 50.1127C215.803 48.6154 215.477 46.8608 214.628 45.3907C214.057 44.4083 213.255 43.5547 212.291 42.9789C209.865 41.5359 207.31 42.3895 206.59 44.8826C206.155 46.3798 206.481 48.1344 207.33 49.6046Z",
    fill: "url(#paint62_radial_150_1314)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M214.458 45.4924C215.314 46.9625 215.634 48.7171 215.199 50.2144C214.472 52.7142 211.924 53.5611 209.498 52.1181C208.526 51.5422 207.724 50.6818 207.16 49.7062C206.304 48.2361 205.985 46.4815 206.42 44.9843C207.14 42.4912 209.695 41.6375 212.121 43.0806C213.092 43.6564 213.894 44.5168 214.458 45.4924ZM206.182 50.2618C206.902 51.5016 207.915 52.5923 209.145 53.324C212.216 55.1531 215.45 54.0759 216.367 50.9122C216.918 49.0152 216.51 46.7931 215.43 44.9301C214.709 43.6903 213.697 42.5996 212.467 41.8679C209.396 40.0387 206.162 41.1159 205.244 44.2797C204.694 46.1766 205.102 48.3987 206.182 50.2618Z",
    fill: "url(#paint63_linear_150_1314)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M209.138 44.1239L208.886 44.9978L209.185 45.174C209.117 45.2214 209.049 45.2891 208.968 45.3704C208.886 45.4517 208.812 45.5534 208.73 45.6685L207.935 45.1943L207.779 45.2891L207.84 45.4653L207.86 45.4788L207.69 46.0615L208.383 46.4747C208.309 46.7322 208.275 46.9896 208.275 47.2674C208.275 47.5384 208.309 47.8026 208.383 48.0532C208.438 48.2362 208.513 48.4055 208.601 48.5681C208.635 48.6291 208.676 48.6901 208.716 48.7443C208.866 48.9543 209.056 49.1304 209.294 49.2727C209.613 49.4624 209.892 49.5505 210.13 49.5369C210.368 49.5166 210.571 49.4488 210.748 49.3269C210.925 49.2049 211.081 49.0423 211.21 48.8459C211.339 48.6494 211.462 48.4733 211.57 48.3039C211.679 48.1345 211.788 48.0058 211.89 47.9177C211.992 47.8229 212.107 47.8093 212.223 47.8839C212.27 47.911 212.304 47.9516 212.338 48.0058C212.358 48.0397 212.372 48.0736 212.386 48.121C212.426 48.2362 212.42 48.3784 212.372 48.541C212.304 48.7849 212.168 48.9611 211.964 49.0694C211.76 49.1778 211.523 49.1846 211.244 49.0965L211.088 49.1914L211.183 49.3269L210.932 50.2008L212.345 51.0409L212.555 51.3525L212.712 51.2645L213.031 50.1602L212.746 49.9908C212.97 49.8147 213.147 49.6182 213.276 49.4014L213.799 49.713L213.86 49.9366L214.016 49.8418L214.268 48.9814L213.595 48.5817C213.656 48.3242 213.69 48.06 213.704 47.789C213.711 47.5248 213.683 47.2674 213.615 47.0167C213.568 46.8338 213.493 46.6576 213.398 46.4951C213.364 46.4409 213.33 46.3867 213.296 46.3325C213.147 46.1224 212.956 45.9463 212.712 45.804C212.386 45.6076 212.1 45.5195 211.862 45.533C211.625 45.5466 211.414 45.6211 211.23 45.7498C211.054 45.8785 210.898 46.0411 210.762 46.2376C210.626 46.4341 210.503 46.617 210.395 46.7864C210.286 46.9557 210.177 47.0845 210.075 47.1861C209.973 47.2877 209.865 47.3012 209.749 47.2335C209.695 47.1996 209.647 47.159 209.62 47.1048C209.6 47.0641 209.579 47.0235 209.573 46.9693C209.545 46.8473 209.552 46.7186 209.593 46.5831C209.627 46.4747 209.674 46.3731 209.749 46.285C209.824 46.197 209.906 46.1292 209.994 46.0818C210.089 46.0344 210.191 46.0073 210.306 46.0005C210.34 46.0005 210.381 46.0005 210.415 46.0005L210.49 46.1495L210.646 46.0615L210.972 44.9436L209.233 43.9071L209.077 44.002L209.165 44.151L209.138 44.1239Z",
    fill: "url(#paint64_linear_150_1314)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M208.431 48.6426C208.465 48.7036 208.506 48.7645 208.546 48.8187C208.696 49.0287 208.886 49.2049 209.124 49.3472C209.443 49.5368 209.722 49.6249 209.96 49.6114C210.197 49.591 210.401 49.5233 210.578 49.4013C210.755 49.2794 210.911 49.1168 211.04 48.9203C211.169 48.7239 211.291 48.5477 211.4 48.3784C211.509 48.209 211.618 48.0803 211.72 47.9922C211.821 47.8974 211.937 47.8838 212.052 47.9583C212.1 47.9854 212.134 48.0261 212.168 48.0803C212.188 48.1142 212.202 48.148 212.216 48.1954C212.256 48.3106 212.249 48.4529 212.202 48.6155C212.134 48.8594 211.998 49.0355 211.794 49.1439C211.59 49.2523 211.353 49.2591 211.074 49.171L210.755 50.2753L212.535 51.3389L212.854 50.2346L212.569 50.0653C212.793 49.8891 212.97 49.6927 213.099 49.4759L213.839 49.9162L214.091 49.0558L213.418 48.6561C213.479 48.3987 213.513 48.1345 213.527 47.8635C213.534 47.5993 213.507 47.3418 213.439 47.0912C213.391 46.9082 213.316 46.7321 213.221 46.5695C213.187 46.5153 213.153 46.4611 213.119 46.4069C212.97 46.1969 212.779 46.0208 212.535 45.8785C212.209 45.682 211.923 45.594 211.686 45.6075C211.448 45.6211 211.237 45.6956 211.054 45.8243C210.877 45.953 210.721 46.1156 210.585 46.3121C210.449 46.5085 210.327 46.6915 210.218 46.8608C210.109 47.0302 210 47.1589 209.899 47.2605C209.797 47.3622 209.688 47.3757 209.572 47.308C209.518 47.2741 209.47 47.2334 209.443 47.1792C209.423 47.1386 209.402 47.0979 209.396 47.0437C209.369 46.9218 209.382 46.7931 209.416 46.6576C209.45 46.5492 209.498 46.4476 209.572 46.3595C209.647 46.2714 209.729 46.2037 209.817 46.1563C209.912 46.1088 210.014 46.0817 210.13 46.075C210.245 46.0682 210.361 46.0885 210.476 46.1359L210.802 45.0181L209.063 43.9816L208.737 45.0994L209.036 45.2755C208.968 45.323 208.9 45.3907 208.818 45.472C208.737 45.5533 208.662 45.6549 208.58 45.7701L207.785 45.2959L207.534 46.1563L208.227 46.5695C208.152 46.827 208.118 47.0844 208.118 47.3622C208.118 47.6331 208.152 47.8974 208.227 48.148C208.281 48.3309 208.356 48.5003 208.444 48.6629L208.431 48.6426Z",
    fill: "url(#paint65_linear_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M212.168 48.0803C212.168 48.0803 212.202 48.1481 212.216 48.1955C212.256 48.3107 212.25 48.4529 212.202 48.6155C212.148 48.7917 212.066 48.9339 211.944 49.0423C211.774 49.5843 211.529 50.0992 211.251 50.5666L212.535 51.3322L212.854 50.2279L212.569 50.0585C212.793 49.8824 212.97 49.6859 213.099 49.4691L213.84 49.9095L214.091 49.0491L213.418 48.6494C213.479 48.392 213.513 48.1277 213.527 47.8568C213.534 47.5925 213.507 47.3351 213.439 47.0844C213.391 46.9015 213.316 46.7254 213.221 46.5628C213.187 46.5086 213.153 46.4544 213.119 46.4002C212.97 46.1902 212.78 46.014 212.535 45.8718C212.406 45.7972 212.284 45.7363 212.161 45.6888C212.263 46.556 212.277 47.3758 212.175 48.0871L212.168 48.0803Z",
    fill: "url(#paint66_linear_150_1314)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M211.611 42.8095C211.781 42.8908 211.95 42.9788 212.12 43.0737C213.092 43.6495 213.894 44.5099 214.458 45.4855C215.314 46.9556 215.633 48.7103 215.198 50.2075C214.512 52.5651 212.202 53.4526 209.905 52.3347C209.586 52.6735 209.267 52.9648 208.974 53.2155C209.029 53.2493 209.09 53.29 209.151 53.3238C212.222 55.153 215.457 54.0758 216.374 50.912C216.924 49.0151 216.517 46.793 215.436 44.93C214.716 43.6902 213.704 42.5995 212.474 41.8678C212.046 41.6171 211.618 41.4207 211.196 41.2716C211.346 41.7594 211.488 42.2743 211.618 42.8027L211.611 42.8095Z",
    fill: "url(#paint67_linear_150_1314)"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M335.316 67.5444L335.819 67.8899L335.901 67.6122C336.573 67.3886 337.463 66.3114 338.401 64.4281C339.821 61.5894 340.935 57.7753 341.262 54.8892C341.357 54.0763 341.384 53.3311 341.343 52.7078C341.289 51.9287 341.126 51.4138 340.874 51.1496L340.942 50.926L340.399 50.9531C339.712 50.9938 338.734 52.0981 337.694 54.1847C336.274 57.0233 335.16 60.8375 334.834 63.7235C334.739 64.5365 334.711 65.2817 334.752 65.905C334.813 66.7857 335.017 67.3276 335.323 67.5512L335.316 67.5444Z",
    fill: "url(#paint68_linear_150_1314)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M337.912 68.4993L338.822 65.5184C338.958 65.2813 339.094 65.0239 339.23 64.7529C340.677 61.8601 341.805 57.9782 342.145 55.0447C342.165 54.8618 342.186 54.6856 342.199 54.5163L343.11 51.5489L341.065 50.946C340.365 50.736 339.271 51.8674 338.095 54.2114C336.648 57.1042 335.52 60.9861 335.187 63.9196C335.092 64.7461 335.065 65.5049 335.106 66.1349C335.18 67.2189 335.466 67.8015 335.887 67.9031L337.919 68.4993H337.912Z",
    fill: "url(#paint69_linear_150_1314)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M338.048 68.5197H338.061C338.122 68.5197 338.19 68.5129 338.251 68.4926L338.496 68.4587L338.523 68.3774C339.175 68.0116 339.991 66.948 340.847 65.234C342.294 62.3411 343.422 58.4592 343.762 55.5258C343.857 54.6992 343.884 53.9405 343.843 53.3104C343.803 52.6872 343.687 52.2332 343.524 51.9419L343.544 51.881L343.375 51.7319C343.341 51.6913 343.3 51.6574 343.259 51.6303C342.573 51.1628 341.397 52.2807 340.134 54.8144C338.686 57.7072 337.558 61.5891 337.225 64.5226C337.13 65.3491 337.103 66.1079 337.144 66.7379C337.225 67.9303 337.565 68.5129 338.054 68.5197H338.048Z",
    fill: "url(#paint70_linear_150_1314)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M338.578 67.4222C337.586 67.1308 337.749 63.6215 338.945 59.5906C340.141 55.5596 341.914 52.5245 342.913 52.8158C343.912 53.1072 343.742 56.6165 342.546 60.6474C341.35 64.6784 339.577 67.7135 338.578 67.4222Z",
    fill: "url(#paint71_linear_150_1314)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M338.612 66.6295C337.715 66.3653 337.864 63.215 338.938 59.5906C340.011 55.9661 341.608 53.2426 342.505 53.5068C343.402 53.7711 343.253 56.9213 342.179 60.5458C341.105 64.1703 339.509 66.8937 338.612 66.6295Z",
    fill: "url(#paint72_radial_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M338.612 66.6295C337.715 66.3653 337.864 63.215 338.938 59.5906C340.011 55.9661 341.608 53.2426 342.505 53.5068C343.402 53.7711 343.253 56.9213 342.179 60.5458C341.105 64.1703 339.509 66.8937 338.612 66.6295Z",
    fill: "url(#paint73_radial_150_1314)"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M338.272 63.6012C338.53 61.3249 339.407 58.3169 340.528 56.0744C341.968 53.202 343.259 52.6803 343.415 54.9092C343.449 55.4038 343.429 55.9864 343.354 56.63C343.096 58.9063 342.22 61.9143 341.098 64.1567C339.658 67.0292 338.367 67.5508 338.211 65.322C338.177 64.8274 338.197 64.2448 338.272 63.6012ZM344.034 55.6951C344.129 54.8821 344.156 54.1369 344.115 53.5136C343.918 50.6885 342.281 51.3457 340.46 54.9905C339.04 57.8291 337.925 61.6433 337.599 64.5293C337.504 65.3423 337.477 66.0875 337.518 66.7108C337.715 69.5358 339.352 68.8787 341.173 65.2339C342.593 62.3953 343.708 58.5811 344.034 55.6951Z",
    fill: "url(#paint74_linear_150_1314)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M339.04 63.852L339.257 63.4184C339.277 63.6352 339.318 63.8113 339.366 63.9468C339.413 64.0823 339.481 64.1636 339.563 64.1772L339.74 64.2314V64.123C339.78 64.0959 339.814 64.0688 339.848 64.0349C339.957 63.9197 340.086 63.7165 340.229 63.4252C340.419 63.039 340.575 62.6664 340.684 62.3006C340.793 61.9415 340.881 61.596 340.942 61.2776C340.983 61.0472 341.017 60.8304 341.044 60.6204C341.051 60.5324 341.064 60.4443 341.071 60.363L341.132 59.5703C341.146 59.4281 341.16 59.2994 341.173 59.1706C341.18 59.0826 341.194 58.9945 341.207 58.9132C341.234 58.7167 341.282 58.5474 341.357 58.4119C341.411 58.2967 341.459 58.2493 341.499 58.2696C341.533 58.2899 341.554 58.3644 341.567 58.4864C341.574 58.5812 341.567 58.71 341.554 58.8522C341.533 59.0013 341.513 59.1503 341.479 59.3129C341.445 59.4755 341.404 59.6381 341.35 59.8075C341.296 59.9768 341.241 60.1326 341.173 60.2817L341.241 61.2776L341.418 61.3318V60.905L342.267 59.2181L342.226 58.6016L342.383 58.2764L342.206 58.2222L342.029 58.5745C342.05 58.4593 342.07 58.317 342.09 58.168C342.097 58.1002 342.111 58.0257 342.118 57.958C342.124 57.8699 342.138 57.775 342.145 57.6802L342.614 56.7385L342.587 56.3862L342.736 56.0204L342.559 55.9662L342.152 56.7859C342.138 56.5556 342.097 56.3794 342.05 56.2507C341.995 56.122 341.927 56.0543 341.839 56.0407C341.758 56.0272 341.656 56.0814 341.54 56.2033C341.425 56.3252 341.302 56.5217 341.16 56.8063C340.969 57.1856 340.82 57.5515 340.711 57.9105C340.602 58.2628 340.521 58.6016 340.46 58.92C340.419 59.1503 340.385 59.3671 340.358 59.5771C340.351 59.6584 340.337 59.7397 340.337 59.821C340.317 60.1055 340.297 60.363 340.276 60.6001C340.27 60.7153 340.256 60.8304 340.242 60.9388C340.229 61.0472 340.215 61.1489 340.202 61.2505C340.168 61.4469 340.12 61.6163 340.052 61.7586C340.011 61.8399 339.971 61.8873 339.923 61.8941C339.882 61.8941 339.855 61.8263 339.848 61.6773C339.841 61.5621 339.848 61.4266 339.862 61.2708C339.875 61.1353 339.903 60.993 339.937 60.8304C340.011 60.4849 340.12 60.1259 340.27 59.7668L340.236 59.2452L340.385 58.8319L340.208 58.7777L339.155 60.8846L339.223 61.867L339.332 61.9008C339.318 62.0092 339.305 62.1109 339.291 62.2125C339.277 62.3412 339.264 62.4632 339.257 62.5783L338.815 63.459L338.87 64.2314L339.046 64.2856V63.8655L339.04 63.852Z",
    fill: "url(#paint75_linear_150_1314)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M342.784 56.779L342.729 56.0067L342.322 56.8265C342.308 56.5961 342.267 56.42 342.22 56.2913C342.165 56.1625 342.097 56.0948 342.009 56.0812C341.927 56.0677 341.826 56.1219 341.71 56.2438C341.594 56.3658 341.472 56.5622 341.33 56.8468C341.139 57.2262 340.99 57.592 340.881 57.9511C340.772 58.3033 340.691 58.6421 340.63 58.9605C340.589 59.1908 340.555 59.4076 340.528 59.6176C340.521 59.6989 340.507 59.7802 340.507 59.8615C340.487 60.1461 340.467 60.4035 340.446 60.6406C340.439 60.7558 340.426 60.871 340.412 60.9794C340.399 61.0878 340.385 61.1894 340.371 61.291C340.337 61.4875 340.29 61.6568 340.222 61.7991C340.181 61.8804 340.14 61.9278 340.093 61.9346C340.052 61.9346 340.025 61.8669 340.018 61.7178C340.011 61.6026 340.018 61.4671 340.032 61.3113C340.045 61.1758 340.072 61.0336 340.106 60.871C340.181 60.5255 340.29 60.1664 340.439 59.8073L340.371 58.8182L339.318 60.9252L339.386 61.9075L339.556 61.5688C339.515 61.8194 339.481 62.0498 339.454 62.253C339.441 62.3817 339.427 62.5037 339.42 62.6189L338.979 63.4996L339.033 64.2719L339.434 63.4725C339.454 63.6893 339.495 63.8654 339.542 64.0009C339.59 64.1364 339.658 64.2177 339.74 64.2312C339.821 64.2516 339.916 64.1974 340.025 64.0822C340.134 63.967 340.263 63.7638 340.405 63.4725C340.596 63.0863 340.752 62.7137 340.861 62.3479C340.969 61.9888 341.058 61.6433 341.119 61.3249C341.16 61.0945 341.194 60.8777 341.221 60.6677C341.228 60.5797 341.241 60.4916 341.248 60.4103C341.268 60.119 341.296 59.8548 341.309 59.6176C341.323 59.4754 341.336 59.3467 341.35 59.2179C341.357 59.1299 341.37 59.0418 341.384 58.9605C341.411 58.764 341.459 58.5947 341.533 58.4592C341.588 58.344 341.635 58.2966 341.676 58.3169C341.71 58.3372 341.73 58.4117 341.744 58.5337C341.751 58.6285 341.744 58.7573 341.73 58.8995C341.71 59.0486 341.69 59.1976 341.656 59.3602C341.622 59.5228 341.581 59.6854 341.527 59.8548C341.472 60.0241 341.418 60.1799 341.35 60.329L341.418 61.3249L342.451 59.2654L342.383 58.2695L342.206 58.6218C342.226 58.5066 342.247 58.3643 342.267 58.2153C342.274 58.1475 342.288 58.073 342.294 58.0053C342.301 57.9172 342.315 57.8223 342.322 57.7275L342.79 56.7858L342.784 56.779Z",
    fill: "url(#paint76_linear_150_1314)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M343.545 51.8813L343.375 51.7323C343.341 51.6916 343.3 51.6578 343.259 51.6307C343.212 51.5968 343.157 51.5697 343.103 51.5561L341.058 50.9532C341.017 50.9464 340.983 50.9396 340.942 50.9329H340.935C340.881 50.9329 340.827 50.9329 340.772 50.9329L340.399 50.9464C339.712 50.9871 338.734 52.0913 337.694 54.178C336.274 57.0166 335.16 60.8307 334.834 63.7168C334.739 64.5297 334.711 65.275 334.752 65.8982C334.813 66.779 335.017 67.3209 335.323 67.5445L335.588 67.7274C335.649 67.7952 335.724 67.8358 335.792 67.8697L335.819 67.89C335.819 67.89 335.86 67.9036 335.88 67.9103L337.912 68.5065C337.959 68.5065 338 68.5201 338.054 68.5268H338.068C338.129 68.5268 338.197 68.5201 338.258 68.4997L338.503 68.4659C339.189 68.3778 340.147 67.2803 341.166 65.2411C342.587 62.4025 343.701 58.5883 344.027 55.7023C344.122 54.8893 344.149 54.1441 344.109 53.5208C344.047 52.6401 343.844 52.0981 343.545 51.8813Z",
    fill: "url(#paint77_linear_150_1314)"
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M259.072 67.0767C248.398 68.1268 239.897 86.3372 239.897 108.66C239.897 130.983 248.398 149.193 259.072 150.243L296.206 154.335L296.314 63.1609L259.072 67.0767Z",
    fill: "url(#paint78_linear_150_1314)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M296.511 154.349C303.06 154.349 308.368 133.933 308.368 108.748C308.368 83.5635 303.06 63.1473 296.511 63.1473C289.963 63.1473 284.655 83.5635 284.655 108.748C284.655 133.933 289.963 154.349 296.511 154.349Z",
    fill: "url(#paint79_linear_150_1314)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M296.512 153.217C302.557 153.217 307.458 133.308 307.458 108.748C307.458 84.1883 302.557 64.2787 296.512 64.2787C290.466 64.2787 285.565 84.1883 285.565 108.748C285.565 133.308 290.466 153.217 296.512 153.217Z",
    fill: "url(#paint80_radial_150_1314)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M351.107 57.4768H305.331C299.542 57.4768 294.847 80.416 294.847 108.714C294.847 137.012 299.542 159.951 305.331 159.951H351.107C356.897 159.951 361.592 137.012 361.592 108.714C361.592 80.416 356.897 57.4768 351.107 57.4768Z",
    fill: "url(#paint81_linear_150_1314)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M342.872 78.7902L338.143 101.364L338.102 99.4599L342.811 76.087L342.872 78.7902Z",
    fill: "#803608"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M337.619 135.562C337.619 135.562 336.573 127.853 341.825 115.963C347.071 104.073 349.626 102.509 352.697 94.5821C355.768 86.6556 355.768 81.8049 355.768 81.8049L346.249 101.445L339.379 112.312L336.872 122.541L336.471 132.832L337.619 135.562Z",
    fill: "#85001F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M337.722 140.257L337.117 141.368L316.549 141.585L315.802 140.528L337.722 140.257Z",
    fill: "#85001F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M322.753 90.4088C315.611 90.7205 315.673 103.633 315.795 103.667C315.917 103.701 316.882 104.737 316.882 104.737L317.351 106.81L317.337 104.798C317.337 104.256 316.875 90.9101 329.024 96.7296L331.905 92.4141C331.905 92.4141 326.802 90.5375 322.753 90.4088Z",
    fill: "url(#paint82_linear_150_1314)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M316.882 104.737L317.351 106.81L302.192 106.885L301.091 104.934L316.882 104.737Z",
    fill: "#85001F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M328.427 75.6535C329.5 75.64 330.499 75.7077 331.43 75.8296C332.361 75.9516 333.217 76.121 333.991 76.3107C334.766 76.5071 335.466 76.7171 336.077 76.9271C336.689 77.1372 337.212 77.3404 337.64 77.503L338.625 77.9298C338.938 78.0653 339.244 78.2008 339.536 78.3295C339.835 78.4582 340.12 78.5734 340.392 78.6683C340.664 78.7699 340.915 78.8512 341.146 78.9054C341.377 78.9596 341.588 78.9934 341.771 78.9934C341.934 78.9934 342.077 78.9867 342.199 78.9731C342.322 78.9596 342.424 78.946 342.512 78.9257C342.6 78.9054 342.668 78.885 342.729 78.8647C342.791 78.8444 342.838 78.8173 342.872 78.797L342.804 76.0939L355.585 75.9313L355.755 80.2739C355.83 82.1437 355.646 83.9322 355.266 85.6665C354.885 87.4077 354.301 89.0878 353.587 90.7408C352.867 92.4006 352.011 94.0266 351.073 95.6593C350.136 97.292 349.117 98.9247 348.084 100.585C347.934 100.822 347.785 101.059 347.635 101.296C347.486 101.533 347.336 101.77 347.187 102.014C347.037 102.251 346.888 102.495 346.738 102.739C346.589 102.983 346.439 103.227 346.297 103.471C345.169 105.388 344.048 107.373 343.001 109.459C341.948 111.56 340.976 113.768 340.154 116.133C339.325 118.51 338.646 121.051 338.191 123.801C337.735 126.566 337.504 129.553 337.572 132.805L337.735 140.251L315.815 140.522L315.802 134.912C315.788 130.691 316.413 126.464 317.446 122.358C318.472 118.287 319.906 114.337 321.537 110.631C323.154 106.953 324.968 103.511 326.769 100.429C328.562 97.3665 330.343 94.6498 331.919 92.4006C331.579 92.3261 331.246 92.2448 330.913 92.1567C330.58 92.0687 330.254 91.9806 329.935 91.8925C329.616 91.8045 329.303 91.7164 328.997 91.6283C328.692 91.5402 328.399 91.4522 328.121 91.3709C327.645 91.2489 327.169 91.1405 326.694 91.0525C326.218 90.9644 325.736 90.8899 325.26 90.8289C324.778 90.7679 324.302 90.7273 323.82 90.7002C323.337 90.6731 322.855 90.6663 322.379 90.6731C321.557 90.6866 320.796 90.9712 320.13 91.4928C319.457 92.0212 318.873 92.7868 318.397 93.7556C317.915 94.7311 317.535 95.9099 317.283 97.2649C317.025 98.6198 316.889 100.158 316.896 101.831L316.909 104.717L301.118 104.914L301.417 76.4055L313.451 76.2565L313.757 78.7225C313.92 78.675 314.103 78.6208 314.307 78.5531C314.511 78.4853 314.742 78.4108 315 78.3227C315.258 78.2347 315.537 78.1331 315.843 78.0179C316.148 77.9027 316.488 77.7808 316.855 77.6385C317.643 77.3269 318.479 77.0491 319.369 76.8052C320.259 76.5613 321.19 76.3581 322.169 76.1887C323.147 76.0193 324.159 75.8906 325.213 75.7958C326.266 75.7009 327.346 75.6467 328.46 75.6332L328.427 75.6535Z",
    fill: "url(#paint83_linear_150_1314)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M316.889 139.431L316.876 134.919C316.869 131.044 317.406 126.911 318.486 122.636C319.424 118.917 320.776 115.035 322.515 111.085C323.976 107.772 325.716 104.378 327.693 100.991C329.262 98.3149 330.975 95.6389 332.796 93.0374L333.72 91.7163L332.143 91.364C331.817 91.2895 331.491 91.2082 331.172 91.1269C330.846 91.0456 330.526 90.9575 330.214 90.8695L328.413 90.3478C327.89 90.2123 327.387 90.0971 326.884 90.0023C326.381 89.9075 325.879 89.8262 325.376 89.7652C324.873 89.7042 324.363 89.6636 323.861 89.6297C323.358 89.6026 322.848 89.589 322.345 89.5958C321.292 89.6094 320.314 89.9616 319.437 90.6459C318.642 91.2692 317.956 92.1567 317.399 93.2813C316.869 94.3517 316.461 95.6253 316.189 97.0683C315.917 98.5181 315.782 100.124 315.782 101.838V103.653L302.185 103.823L302.464 77.4826L312.459 77.3607L312.799 80.1247L314.022 79.7725C314.198 79.725 314.389 79.6641 314.613 79.5895C314.824 79.5218 315.061 79.4405 315.326 79.3524C315.585 79.2644 315.877 79.156 316.189 79.0408C316.502 78.9256 316.842 78.7969 317.215 78.6546C317.97 78.3498 318.778 78.0856 319.621 77.8552C320.47 77.6249 321.374 77.4216 322.318 77.259C323.256 77.0964 324.255 76.9677 325.274 76.8797C326.3 76.7916 327.36 76.7374 328.44 76.7238C329.385 76.7103 330.343 76.7645 331.287 76.8864C332.096 76.988 332.918 77.1439 333.727 77.3471C334.379 77.5097 335.031 77.7062 335.724 77.9365C336.288 78.1262 336.771 78.3159 337.178 78.4717C337.178 78.4717 338.809 79.1831 339.115 79.3118C339.427 79.4473 339.733 79.5692 340.018 79.6708C340.331 79.786 340.623 79.8809 340.888 79.9418C341.221 80.0231 341.513 80.0638 341.785 80.057C341.989 80.057 342.159 80.0434 342.308 80.0299C342.485 80.0096 342.628 79.9893 342.743 79.9622C342.899 79.9283 343.022 79.8876 343.124 79.847C343.232 79.8063 343.328 79.7589 343.409 79.7115L343.973 79.3931L343.919 77.1371L354.539 77.0016L354.668 80.2941C354.736 82.0013 354.58 83.6815 354.199 85.4158C353.853 86.9943 353.323 88.5864 352.582 90.2936C351.943 91.7637 351.162 93.2948 350.122 95.1037C349.212 96.689 348.233 98.2539 347.201 99.907L346.249 101.424L345.801 102.149L345.352 102.888C344.401 104.507 343.164 106.655 342.016 108.951C340.834 111.309 339.883 113.531 339.115 115.753C338.204 118.355 337.552 120.929 337.11 123.605C336.621 126.559 336.41 129.655 336.478 132.805L336.614 139.16L316.889 139.404V139.431Z",
    fill: "url(#paint84_linear_150_1314)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M303.449 80.0637L311.575 79.9621L311.949 82.9972L314.293 82.3197C314.477 82.2655 314.681 82.2045 314.912 82.13C315.129 82.0555 315.374 81.9742 315.645 81.8793C315.91 81.7845 316.203 81.6829 316.529 81.5609C316.848 81.4458 317.188 81.317 317.568 81.168C318.295 80.8767 319.07 80.6192 319.879 80.3957C320.694 80.1721 321.57 79.9824 322.481 79.8198C323.391 79.664 324.356 79.5353 325.355 79.4472C326.354 79.3591 327.394 79.3049 328.447 79.2982H328.685C329.507 79.2982 330.336 79.3524 331.158 79.454C331.926 79.5488 332.707 79.6979 333.482 79.8944C334.107 80.0502 334.732 80.2399 335.391 80.4634C335.914 80.6396 336.376 80.8157 336.764 80.9648L336.818 80.9851C336.818 80.9851 338.415 81.6829 338.714 81.8116C339.047 81.9539 339.366 82.0826 339.665 82.191C340.018 82.3197 340.344 82.4213 340.643 82.4958C341.044 82.5907 341.404 82.6381 341.751 82.6381C342.029 82.6381 342.233 82.6246 342.41 82.6042C342.634 82.5839 342.811 82.55 342.96 82.5162C343.151 82.4755 343.327 82.4213 343.497 82.3536C343.626 82.3062 343.769 82.2384 343.912 82.1571L344.985 81.5474L344.951 79.9824L343.912 80.5718C343.769 80.6531 343.626 80.7209 343.497 80.7683C343.334 80.836 343.151 80.8902 342.96 80.9309C342.811 80.9648 342.627 80.9919 342.41 81.019C342.24 81.0393 342.036 81.0461 341.751 81.0528C341.411 81.0528 341.051 81.0054 340.643 80.9106C340.344 80.836 340.018 80.7344 339.665 80.6057C339.359 80.4973 339.04 80.3686 338.714 80.2263C338.415 80.0976 336.818 79.3998 336.818 79.3998L336.764 79.3795C336.376 79.2304 335.921 79.0611 335.391 78.8781C334.732 78.6546 334.107 78.4649 333.482 78.3091C332.707 78.1194 331.926 77.9703 331.158 77.8687C330.336 77.7603 329.507 77.7129 328.685 77.7129H328.447C327.4 77.7264 326.354 77.7806 325.355 77.8687C324.356 77.9568 323.391 78.0787 322.481 78.2413C321.57 78.3971 320.694 78.5936 319.879 78.8172C319.063 79.0407 318.289 79.2982 317.568 79.5895C317.195 79.7318 316.848 79.8673 316.529 79.9824C316.209 80.1044 315.917 80.206 315.645 80.3008C315.374 80.3957 315.129 80.477 314.912 80.5515C314.681 80.626 314.477 80.687 314.293 80.7412L311.949 81.4187L311.575 78.3836L303.449 78.4852L303.191 102.84H303.204L303.442 80.0773L303.449 80.0637Z",
    fill: "#85001F"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M335.479 134.444L335.561 138.211H335.595L335.479 132.927C335.479 133.435 335.466 133.943 335.479 134.451V134.444Z",
    fill: "#85001F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M334.059 92.9629L333.611 93.6065C331.81 96.1809 330.105 98.8366 328.549 101.492C326.592 104.839 324.866 108.199 323.419 111.485C321.706 115.38 320.368 119.215 319.444 122.88C318.384 127.08 317.854 131.125 317.867 134.919V136.281C317.881 132.554 318.411 128.584 319.444 124.472C320.368 120.807 321.706 116.973 323.419 113.077C324.866 109.798 326.585 106.438 328.549 103.084C330.105 100.429 331.803 97.773 333.611 95.1986L335.384 92.6648V91.0728L334.059 92.9629Z",
    fill: "#85001F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M272.852 86.6015C271.459 94.2163 270.929 97.2988 269.828 103.593C269.787 103.057 269.767 102.786 269.726 102.244C270.813 95.6864 271.343 92.4413 272.784 84.2845C272.804 85.2262 272.818 85.6869 272.852 86.6015Z",
    fill: "#803608"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M270.78 132.541C271.011 132.873 271.262 133.09 271.582 133.55C264.733 133.09 261.247 132.839 254.391 132.297C254.16 131.951 253.922 131.694 253.732 131.355C260.622 131.884 263.829 132.107 270.78 132.541Z",
    fill: "#85001F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M271.588 133.55C271.588 133.55 271.167 125.861 271.588 119.933C272.01 114.005 276.12 107.068 278.906 103.586C281.692 100.103 284.159 94.8733 284.369 91.9534C284.587 89.0335 284.369 85.7071 284.369 85.7071L283.391 84.3251C283.391 84.3251 283.975 90.4765 281.787 94.9817C279.599 99.4869 274.15 106.993 271.826 111.98C269.502 116.966 269.842 132.073 269.842 132.073L271.582 133.543L271.588 133.55Z",
    fill: "#85001F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M257.924 95.9506C252.618 96.4858 252.93 105.178 253.025 105.198C253.12 105.218 253.888 105.876 253.888 105.876C253.868 105.523 252.006 95.2799 262.762 100.239C263.571 99.0195 263.972 98.4098 264.787 97.1565C264.787 97.1565 260.948 95.8625 257.924 95.9506Z",
    fill: "url(#paint85_linear_150_1314)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M253.888 105.875C253.433 106.445 253.202 106.729 252.74 107.291C248.072 107.413 247.426 107.522 242.174 107.833C241.719 107.312 241.542 107.102 241.229 106.634C246.638 106.214 249.071 106.065 253.888 105.875Z",
    fill: "#85001F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M261.926 84.4335C262.721 84.359 263.462 84.3658 264.148 84.42C264.841 84.4742 265.473 84.5758 266.057 84.7113C266.635 84.84 267.158 84.9958 267.62 85.1516C268.082 85.3075 268.476 85.4633 268.809 85.5852C269.108 85.7207 269.258 85.7885 269.563 85.9172C269.801 86.0256 270.039 86.134 270.263 86.2356C270.494 86.3372 270.712 86.4321 270.922 86.5134C271.133 86.5947 271.33 86.6624 271.507 86.7031C271.69 86.7505 271.853 86.7708 271.989 86.7708C272.118 86.7708 272.227 86.764 272.322 86.7505C272.417 86.7369 272.499 86.7234 272.567 86.7098C272.635 86.6963 272.689 86.676 272.737 86.6556C272.784 86.6353 272.818 86.615 272.852 86.5947C272.818 85.6801 272.804 85.2194 272.784 84.2777C276.786 84.1625 278.845 84.1558 283.391 84.3184C283.459 85.9578 283.499 86.7505 283.588 88.2816C283.683 89.9346 283.561 91.4318 283.275 92.8071C282.99 94.1891 282.535 95.456 281.971 96.6551C281.407 97.861 280.734 98.9992 280.007 100.11C279.28 101.228 278.498 102.326 277.717 103.437C277.602 103.592 277.493 103.755 277.377 103.911C277.262 104.073 277.153 104.229 277.044 104.392C276.936 104.554 276.82 104.71 276.711 104.873C276.603 105.035 276.494 105.198 276.379 105.361C275.543 106.648 274.727 107.976 273.987 109.392C273.239 110.814 272.567 112.325 272.01 113.985C271.452 115.651 271.017 117.454 270.759 119.479C270.494 121.518 270.406 123.774 270.535 126.369C270.651 128.747 270.705 129.973 270.78 132.521C263.829 132.094 260.622 131.863 253.732 131.335C253.732 129.472 253.725 128.578 253.698 126.837C253.657 123.558 254.071 120.543 254.771 117.711C255.471 114.899 256.456 112.257 257.577 109.757C258.692 107.278 259.935 104.941 261.185 102.807C262.429 100.686 263.672 98.7621 264.78 97.1294C264.522 97.0752 264.27 97.021 264.019 96.96C263.767 96.899 263.523 96.8448 263.285 96.7839C263.047 96.7229 262.809 96.6687 262.585 96.6077C262.361 96.5467 262.137 96.4925 261.926 96.4451C261.573 96.3706 261.213 96.3028 260.859 96.2554C260.506 96.2012 260.146 96.1674 259.786 96.1403C259.426 96.1132 259.072 96.0996 258.712 96.1064C258.352 96.1064 257.999 96.1199 257.639 96.147C257.027 96.1945 256.47 96.4316 255.981 96.8313C255.491 97.231 255.07 97.7933 254.73 98.4775C254.391 99.1686 254.133 99.9883 253.976 100.903C253.82 101.824 253.752 102.847 253.806 103.952C253.84 104.717 253.861 105.096 253.895 105.855C249.077 106.045 246.645 106.187 241.236 106.614C241.093 99.9748 240.998 96.9329 241.087 87.5025C245.116 86.8657 247.012 86.5811 250.708 86.073C250.803 86.8589 250.851 87.245 250.953 88.0038C251.075 87.9496 251.218 87.8886 251.374 87.8209C251.53 87.7464 251.707 87.6651 251.897 87.577C252.094 87.4822 252.305 87.3805 252.536 87.2654C252.767 87.1502 253.025 87.0215 253.297 86.8724C253.888 86.554 254.52 86.2627 255.179 85.9985C255.845 85.7343 256.538 85.4972 257.265 85.2871C257.992 85.0771 258.739 84.901 259.521 84.7519C260.295 84.6097 261.097 84.4945 261.926 84.42V84.4335Z",
    fill: "url(#paint86_linear_150_1314)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M254.581 130.529C254.581 129.052 254.568 128.334 254.547 126.925C254.506 123.91 254.86 120.929 255.587 117.955C256.219 115.374 257.15 112.752 258.339 110.083C259.337 107.84 260.533 105.537 261.899 103.2C262.979 101.35 264.175 99.4667 265.466 97.5969C265.731 97.2175 265.86 97.0278 266.125 96.6417C265.65 96.54 265.405 96.4858 264.93 96.391C264.685 96.3368 264.44 96.2826 264.196 96.2284C263.951 96.1742 263.713 96.1132 263.475 96.0523C262.932 95.9168 262.66 95.849 262.123 95.7135C261.729 95.6254 261.356 95.5577 260.982 95.5103C260.608 95.4561 260.234 95.4154 259.861 95.3883C259.487 95.3612 259.106 95.3545 258.733 95.3545C258.359 95.3545 257.979 95.368 257.605 95.4019C256.817 95.4629 256.096 95.7677 255.458 96.2961C254.873 96.7772 254.377 97.4275 253.983 98.2269C253.609 98.9857 253.331 99.8664 253.161 100.842C252.991 101.824 252.93 102.881 252.978 104.013C252.998 104.487 253.012 104.724 253.032 105.205C248.867 105.401 246.754 105.544 242.147 105.93C242.011 99.7038 241.923 96.7839 241.99 88.2681C245.313 87.7397 246.889 87.5025 249.974 87.069C250.083 87.9361 250.144 88.3562 250.253 89.1895C250.627 89.0336 250.817 88.9591 251.191 88.8033C251.32 88.7491 251.469 88.6881 251.639 88.6136C251.802 88.5391 251.979 88.4578 252.183 88.3629C252.38 88.2681 252.597 88.1665 252.835 88.0445C253.073 87.9294 253.331 87.8006 253.603 87.6516C254.167 87.3603 254.771 87.0757 255.403 86.8251C256.035 86.5744 256.708 86.3441 257.408 86.1476C258.108 85.9511 258.841 85.7818 259.596 85.6395C260.35 85.504 261.138 85.3956 261.94 85.3211C262.64 85.2601 263.353 85.2533 264.053 85.3075C264.651 85.355 265.262 85.4498 265.867 85.5853C266.356 85.6937 266.846 85.8292 267.369 86.0053C267.79 86.1476 268.164 86.2899 268.47 86.405C268.47 86.405 269.72 86.9606 269.951 87.0622C270.195 87.1706 270.427 87.2654 270.651 87.3535C270.889 87.4484 271.12 87.5229 271.323 87.5771C271.582 87.6448 271.813 87.6719 272.023 87.6719C272.18 87.6719 272.315 87.6651 272.431 87.6516C272.567 87.638 272.676 87.6177 272.771 87.5974C272.893 87.5703 272.988 87.5364 273.07 87.5025C273.151 87.4687 273.226 87.428 273.294 87.3942L273.736 87.1299C273.708 86.3712 273.695 85.985 273.674 85.2059C277.031 85.1517 278.757 85.1585 282.487 85.3008C282.542 86.5134 282.569 87.1028 282.637 88.2613C282.725 89.7653 282.63 91.1677 282.345 92.5497C282.086 93.803 281.679 95.0225 281.101 96.269C280.605 97.3462 279.994 98.4302 279.199 99.6767C278.499 100.774 277.751 101.831 276.983 102.949C276.698 103.355 276.555 103.559 276.277 103.972C276.141 104.168 276.08 104.263 275.944 104.46C275.808 104.656 275.747 104.758 275.611 104.954C274.911 106.045 274.021 107.481 273.206 109.046C272.37 110.645 271.718 112.176 271.201 113.728C270.596 115.55 270.182 117.379 269.924 119.344C269.645 121.512 269.57 123.856 269.693 126.369C269.795 128.395 269.835 129.431 269.903 131.579C263.679 131.206 260.764 131.01 254.588 130.536L254.581 130.529Z",
    fill: "url(#paint87_linear_150_1314)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M257.89 116.37C260.676 107.671 267.369 97.6308 267.369 97.6308V96.1742H267.362C266.852 96.9126 266.601 97.2785 266.098 98.0101C264.821 99.8529 263.638 101.716 262.565 103.545C261.213 105.855 260.03 108.138 259.045 110.367C257.876 113.009 256.966 115.611 256.341 118.172C255.627 121.105 255.281 124.039 255.328 126.992C255.342 128.09 255.349 128.645 255.355 129.784C255.695 129.811 256.015 129.831 256.334 129.858C256.334 129.858 255.104 125.075 257.89 116.376V116.37Z",
    fill: "#85001F"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M243.818 90.0024L243.981 105.171L242.969 105.259C242.969 105.259 242.67 92.1771 242.813 90.165L243.818 90.0024Z",
    fill: "#85001F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M242.812 90.1648C245.496 89.7312 246.78 89.5348 249.308 89.1757C249.437 90.0903 249.498 90.5374 249.627 91.4181C250.355 91.1268 250.708 90.9846 251.428 90.7C251.571 90.6458 251.72 90.5781 251.897 90.5036C252.067 90.429 252.25 90.3477 252.454 90.2529C252.658 90.1581 252.875 90.0564 253.12 89.9413C253.358 89.8261 253.616 89.6974 253.901 89.5619C254.438 89.2909 255.023 89.0267 255.627 88.7963C256.232 88.566 256.884 88.356 257.557 88.1663C258.23 87.9834 258.943 87.8208 259.684 87.692C260.424 87.5633 261.192 87.4685 261.967 87.4007C262.035 87.4007 262.075 87.394 262.143 87.3872C262.748 87.3465 263.366 87.3533 263.978 87.4007C264.549 87.4482 265.133 87.5362 265.711 87.6717C266.18 87.7801 266.648 87.9088 267.151 88.0782C267.552 88.2069 267.899 88.3424 268.191 88.4508L268.232 88.4644C268.232 88.4644 269.455 89.0063 269.686 89.108C269.944 89.2164 270.188 89.3248 270.426 89.4128C270.698 89.5144 270.956 89.6025 271.187 89.6567C271.5 89.738 271.785 89.7787 272.043 89.7787C272.261 89.7787 272.417 89.7719 272.553 89.7583C272.723 89.7448 272.866 89.7177 272.988 89.6974C273.137 89.6635 273.28 89.6228 273.402 89.5754C273.497 89.5415 273.613 89.4873 273.722 89.4196C274.055 89.2299 274.225 89.1351 274.564 88.9386C274.544 88.4237 274.53 88.1595 274.51 87.6311C274.184 87.8208 274.021 87.9156 273.695 88.1121C273.586 88.1798 273.47 88.234 273.375 88.2679C273.246 88.3153 273.103 88.3627 272.961 88.3966C272.838 88.4237 272.702 88.444 272.526 88.4644C272.39 88.4779 272.234 88.4847 272.016 88.4847C271.751 88.4847 271.473 88.444 271.16 88.3627C270.929 88.3018 270.671 88.2205 270.406 88.1189C270.175 88.0308 269.923 87.9292 269.672 87.814C269.441 87.7124 268.218 87.1704 268.218 87.1704L268.177 87.1568C267.885 87.0484 267.538 86.913 267.138 86.7842C266.642 86.6149 266.173 86.4861 265.704 86.3845C265.126 86.2558 264.542 86.1677 263.971 86.1203C263.36 86.0729 262.748 86.0661 262.137 86.1135L261.96 86.1271C261.185 86.1948 260.418 86.2965 259.677 86.4252C258.936 86.5607 258.223 86.7233 257.55 86.9062C256.871 87.0959 256.225 87.3127 255.614 87.5498C255.009 87.7869 254.425 88.0511 253.888 88.3356C253.609 88.4779 253.344 88.6066 253.106 88.7218C252.862 88.8438 252.644 88.9454 252.441 89.0402C252.237 89.1351 252.053 89.2231 251.883 89.2977C251.707 89.3722 251.55 89.4399 251.415 89.5009C250.701 89.7922 250.341 89.9413 249.614 90.2326C249.485 89.3383 249.424 88.8776 249.301 87.9427C246.78 88.3018 245.489 88.4982 242.812 88.9251C242.772 96.6347 242.853 99.4259 242.975 105.259H242.989C242.874 99.8053 242.799 97.1699 242.819 90.1648H242.812Z",
    fill: "#85001F"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M281.665 87.5906C281.706 88.3629 281.733 88.7423 281.774 89.4875C281.774 89.0811 281.774 88.661 281.753 88.241C281.706 87.428 281.685 87.0148 281.645 86.1747C278.641 86.0595 277.228 86.0392 274.476 86.0527C274.496 86.6015 274.503 86.8657 274.524 87.4077C277.269 87.4145 278.675 87.4483 281.665 87.5906Z",
    fill: "#85001F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M268.931 127.602C268.986 128.815 269.013 129.431 269.054 130.691H269.081C269.02 128.93 268.986 128.07 268.904 126.39C268.911 126.789 268.918 127.196 268.931 127.609V127.602Z",
    fill: "#85001F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_150_1314)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint88_linear_150_1314)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint89_linear_150_1314)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_1314",
    x1: 9,
    y1: 32.5,
    x2: 308.926,
    y2: 225.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C60C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487354,
    stopColor: "#3088F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832128,
    stopColor: "#46A2EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_1314",
    x1: 292.905,
    y1: 45.4196,
    x2: 298.285,
    y2: 35.9143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_1314",
    x1: 298.804,
    y1: 47.7617,
    x2: 293.719,
    y2: 33.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_1314",
    x1: 294.79,
    y1: 44.8117,
    x2: 300.26,
    y2: 35.1471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_150_1314",
    x1: 308.845,
    y1: 49.3484,
    x2: 304.526,
    y2: 37.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.974 36.3268) rotate(-109.714) scale(5.8949 2.50317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE7B0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(292.356 33.9922) rotate(-109.714) scale(8.59378 4.99709)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_150_1314",
    x1: 305.159,
    y1: 44.0971,
    x2: 292.573,
    y2: 36.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F6B307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3AD06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EC9D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E69006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D66A05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_150_1314",
    x1: 296.805,
    y1: 37.008,
    x2: 298.914,
    y2: 42.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AA4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#AD4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B76504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BD7105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BA6B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B25B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_150_1314",
    x1: 301.099,
    y1: 38.8815,
    x2: 294.916,
    y2: 41.0971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEA007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_150_1314",
    x1: 302.528,
    y1: 38.9076,
    x2: 321.626,
    y2: 34.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F7EEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EDDAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E0BDB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CE9985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B96C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A03811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_150_1314",
    x1: 221.285,
    y1: 101.36,
    x2: 214.82,
    y2: 90.2494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_150_1314",
    x1: 227.659,
    y1: 96.508,
    x2: 210.078,
    y2: 93.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_150_1314",
    x1: 221.779,
    y1: 99.0871,
    x2: 215.205,
    y2: 87.7894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_150_1314",
    x1: 233.099,
    y1: 86.1253,
    x2: 218.178,
    y2: 83.3545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.681 103.441) rotate(-169.54) scale(6.96 2.94059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_150_1314",
    x1: 227.18,
    y1: 88.1394,
    x2: 212.467,
    y2: 96.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_150_1314",
    x1: 215.545,
    y1: 92.058,
    x2: 222.84,
    y2: 93.4126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AA4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#AD4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B76504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BD7105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BA6B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B25B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_150_1314",
    x1: 219.998,
    y1: 88.8079,
    x2: 218.598,
    y2: 96.3902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_150_1314",
    x1: 263.52,
    y1: 176.649,
    x2: 275.207,
    y2: 166.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_150_1314",
    x1: 273.452,
    y1: 165.455,
    x2: 263.636,
    y2: 177.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_150_1314",
    x1: 261.755,
    y1: 175.408,
    x2: 273.646,
    y2: 165.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_150_1314",
    x1: 263.944,
    y1: 157.668,
    x2: 255.614,
    y2: 168.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(277.095 180.922) rotate(128.722) scale(6.11297 2.59152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_150_1314",
    x1: 270.836,
    y1: 174.257,
    x2: 265.218,
    y2: 167.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_150_1314",
    x1: 264.966,
    y1: 173.137,
    x2: 269.037,
    y2: 168.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AA4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#AD4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B76504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BD7105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BA6B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B25B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_150_1314",
    x1: 264.283,
    y1: 168.335,
    x2: 269.6,
    y2: 172.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_150_1314",
    x1: 274.34,
    y1: 66.4178,
    x2: 259.974,
    y2: 54.6207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_150_1314",
    x1: 262.771,
    y1: 52.2005,
    x2: 271.271,
    y2: 69.0422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_150_1314",
    x1: 275.36,
    y1: 65.9024,
    x2: 260.999,
    y2: 54.1096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_150_1314",
    x1: 274.136,
    y1: 64.6229,
    x2: 262.639,
    y2: 55.1818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.902 59.5953) rotate(-140.773) scale(7.40432 7.39997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE7B0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.852 55.833) rotate(-140.773) scale(11.5849 11.5781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_150_1314",
    x1: 262.938,
    y1: 66.549,
    x2: 273.833,
    y2: 53.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#E99406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28206"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_150_1314",
    x1: 275.523,
    y1: 56.279,
    x2: 260.435,
    y2: 63.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CE7B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C97504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BE6504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AB4A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_150_1314",
    x1: 275.245,
    y1: 56.4198,
    x2: 260.568,
    y2: 63.8718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEA007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_150_1314",
    x1: 258.626,
    y1: 49.4393,
    x2: 240.72,
    y2: 28.0642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F7EEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EDDAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E0BDB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CE9985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B96C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A03811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_150_1314",
    x1: 235.673,
    y1: 136.035,
    x2: 223.494,
    y2: 126.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_150_1314",
    x1: 225.835,
    y1: 124.005,
    x2: 233.04,
    y2: 138.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_150_1314",
    x1: 236.538,
    y1: 135.602,
    x2: 224.359,
    y2: 125.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_150_1314",
    x1: 235.497,
    y1: 134.517,
    x2: 225.752,
    y2: 126.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(230.214 130.256) rotate(-140.773) scale(6.27772 6.27404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE7B0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.564 127.064) rotate(-140.773) scale(9.82039 9.81463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_150_1314",
    x1: 226.008,
    y1: 136.148,
    x2: 235.244,
    y2: 124.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#E99406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28206"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_150_1314",
    x1: 236.661,
    y1: 127.469,
    x2: 223.867,
    y2: 133.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CE7B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C97504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BE6504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AB4A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_150_1314",
    x1: 236.424,
    y1: 127.588,
    x2: 223.981,
    y2: 133.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEA007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_150_1314",
    x1: 223.25,
    y1: 137.453,
    x2: 237.883,
    y2: 122.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F7EEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EDDAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E0BDB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CE9985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B96C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A03811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_150_1314",
    x1: 317.739,
    y1: 165.048,
    x2: 305.565,
    y2: 155.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_150_1314",
    x1: 307.904,
    y1: 153.017,
    x2: 315.109,
    y2: 167.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_150_1314",
    x1: 318.603,
    y1: 164.615,
    x2: 306.425,
    y2: 154.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_150_1314",
    x1: 317.563,
    y1: 163.53,
    x2: 307.818,
    y2: 155.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(312.28 159.269) rotate(-140.773) scale(6.27772 6.27404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE7B0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.63 156.077) rotate(-140.773) scale(9.82039 9.81463)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_150_1314",
    x1: 308.073,
    y1: 165.161,
    x2: 317.308,
    y2: 153.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#E99406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28206"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_150_1314",
    x1: 318.727,
    y1: 156.475,
    x2: 305.933,
    y2: 162.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CE7B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C97504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BE6504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AB4A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_150_1314",
    x1: 318.49,
    y1: 156.594,
    x2: 306.048,
    y2: 162.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEA007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_150_1314",
    x1: 305.324,
    y1: 166.462,
    x2: 319.95,
    y2: 151.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F7EEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EDDAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E0BDB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CE9985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B96C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A03811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_150_1314",
    x1: 207.477,
    y1: 49.2649,
    x2: 216.938,
    y2: 44.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_150_1314",
    x1: 215.759,
    y1: 53.3247,
    x2: 208.703,
    y2: 41.0679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_150_1314",
    x1: 216.869,
    y1: 48.9965,
    x2: 204.712,
    y2: 46.2957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_150_1314",
    x1: 215.274,
    y1: 48.9079,
    x2: 205.644,
    y2: 46.7685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCBB07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.785 47.6529) rotate(-167.546) scale(4.91872 4.90558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AE20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.477 47.227) rotate(-26.742) scale(5.6159 5.60606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_150_1314",
    x1: 209.303,
    y1: 53.6677,
    x2: 211.898,
    y2: 41.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEEF83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDEC7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDE66D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FDDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDCE2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDC20B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDDA55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDDC5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_150_1314",
    x1: 206.792,
    y1: 50.3739,
    x2: 215.63,
    y2: 45.2567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CE7B05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C97504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#BE6504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#AB4A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_150_1314",
    x1: 206.633,
    y1: 50.4653,
    x2: 215.47,
    y2: 45.3481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FDF2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FDEC92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FDE377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FDD652"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_150_1314",
    x1: 213.91,
    y1: 49.2103,
    x2: 212.099,
    y2: 48.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_150_1314",
    x1: 216.221,
    y1: 49.1781,
    x2: 212.114,
    y2: 48.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_150_1314",
    x1: 340.523,
    y1: 51.0744,
    x2: 335.606,
    y2: 67.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFF8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEF5C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FEEFB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDE598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FCD772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FBC643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FAB81E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B85E09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#A84804"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF9A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FCC227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E89C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EAA517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F1B934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F6C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FCDB64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FDDE68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC748"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_150_1314",
    x1: 341.217,
    y1: 51.0032,
    x2: 336.205,
    y2: 68.0067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAD07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FDC52A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FED75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FEF4A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FDF0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FAD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F7BE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_150_1314",
    x1: 343.098,
    y1: 51.374,
    x2: 337.975,
    y2: 68.7546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#DF8506"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E18A08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E89A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F3B51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F7BE1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4AE20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F3A122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FCBB07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F6B306"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#E79E06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#CF7D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC6305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_150_1314",
    x1: 342.716,
    y1: 53.5928,
    x2: 338.913,
    y2: 66.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#D57F06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D07905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#C36905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#AE4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C05604"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410.318 81.4042) rotate(106.516) scale(6.74923 1.62383)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D69B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4740A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(314.884 52.8759) rotate(106.516) scale(7.19647 2.30858)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FEFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FCF9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F9F2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F5E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F0DBC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E9CBA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E1B887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D7A261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#CD8937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C16C05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_150_1314",
    x1: 339.8,
    y1: 72.115,
    x2: 341.495,
    y2: 51.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E69916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#E69006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF5E05"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_150_1314",
    x1: 342.006,
    y1: 55.8232,
    x2: 339.469,
    y2: 64.4289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#AA4604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#AD4E04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#B76504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#BD7105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#BA6B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#B25B04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A84604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#A94D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#BA6205"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A85F04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_150_1314",
    x1: 342.366,
    y1: 60.606,
    x2: 338.875,
    y2: 59.5709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFA817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FDC508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FABF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F4AF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#EEA007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_150_1314",
    x1: 342.398,
    y1: 63.2269,
    x2: 349.205,
    y2: 70.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FCFAF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F7EEEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EDDAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E0BDB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CE9985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B96C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#A03811"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B2C03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_150_1314",
    x1: 268.619,
    y1: 152.174,
    x2: 267.943,
    y2: 64.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#250D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2C0F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#361245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3A144A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#502A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#654075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6D487D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#653F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#402B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#221528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#371845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#441956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#60177F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#73149D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7814A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7A14A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#933FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D3ACE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_150_1314",
    x1: 296.511,
    y1: 32.9998,
    x2: 296.511,
    y2: 32.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#43135B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#481460"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#58196E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#732086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#992BA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C838D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F545FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#4B1466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2E103E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#020204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#493659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6C5083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9C73BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AC7FCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#AA7DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#A678C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9361A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#733977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#541347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#521240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#4C122F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#431216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#431240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#43124E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#431255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#431358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#431B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43135B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_150_1314",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(296.512 102.121) scale(10.661 44.4315)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#0D0510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1D0B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#341441"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C1E5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_150_1314",
    x1: 328.216,
    y1: 158.962,
    x2: 328.216,
    y2: 57.1719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#250D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2C0F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#361245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3A144A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#502A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#654075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#6D487D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#653F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#402B48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#221528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#371845"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#441956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#60177F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#73149D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#7814A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7A14A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#933FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#D3ACE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_150_1314",
    x1: 316.936,
    y1: 97.4342,
    x2: 325.114,
    y2: 99.7094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_150_1314",
    x1: 329.049,
    y1: 141.267,
    x2: 328.166,
    y2: 70.7817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFC524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFF4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FEF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9D474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F4BC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE9E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EB8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#AD4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6E3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E09D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E7AA16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1BD36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F8CB4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFD761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFD558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFCF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFCB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FBC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0B31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE9708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DD9B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EFC24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADA6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FDE072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FEF3C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_150_1314",
    x1: 327.971,
    y1: 143.109,
    x2: 328.721,
    y2: 61.4129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC4708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_150_1314",
    x1: 254.004,
    y1: 100.029,
    x2: 260.015,
    y2: 101.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_150_1314",
    x1: 262.851,
    y1: 133.316,
    x2: 262.192,
    y2: 80.7549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFC524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFF4A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FEF09F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FCE58F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9D474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F4BC4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EE9E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EB8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#AD4300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6E3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E09D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E7AA16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F1BD36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F8CB4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FFD761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FFD65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFD558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FFCF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FFCB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FBC425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F0B31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DE9708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#DD9B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EFC24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADA6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FDE072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FEF3C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_150_1314",
    x1: 261.417,
    y1: 135.081,
    x2: 262.761,
    y2: 65.8029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC4708"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E8A241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F19006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#CD5204"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AA5304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EBA707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFB11B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F5C13B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FACD53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FED766"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FDD664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FDD55D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FDCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FDCB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FAC42A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#F2B31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E9A319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F4C64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FADB6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FCE076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FDE279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FDE482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_150_1314",
    x1: 318.431,
    y1: 173.5,
    x2: 299.526,
    y2: -23.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#590080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#581773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_150_1314",
    x1: 163.183,
    y1: 288.187,
    x2: 163.183,
    y2: -100.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121042,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_1314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_150_1314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlipBack3);
export default __webpack_public_path__ + "static/media/bg-flip-back-3.00506003b6db36df090039f0dad7b44a.svg";
export { ForwardRef as ReactComponent };